// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CancellationPolicies-btnPrimary-TtLBW {
  border-color: var(--btn-primary-bg) !important;
  background-color: var(--btn-primary-bg) !important;
  color: var(--btn-primary-color) !important;
  padding: 11px 20px;
  font-weight: 500;
  font-size: 18px;
  border-radius: 6px;
  -webkit-box-shadow: none !important;
          box-shadow: none !important;
  text-decoration: none !important;
  cursor: pointer;
  line-height: 24px;
  display: inline-block;
}

.CancellationPolicies-btnPrimary-TtLBW:hover,
.CancellationPolicies-btnPrimary-TtLBW:focus,
.CancellationPolicies-btnPrimary-TtLBW:active,
.CancellationPolicies-btnPrimary-TtLBW:active:hover,
.CancellationPolicies-btnPrimary-TtLBW:active:focus,
.CancellationPolicies-btnPrimary-TtLBW[disabled]:hover,
.CancellationPolicies-btnPrimary-TtLBW[disabled]:focus {
  border-color: var(--btn-primary-bg-hover) !important;
  background-color: var(--btn-primary-bg-hover) !important;
  color: var(--btn-primary-color) !important;
  -webkit-box-shadow: none !important;
          box-shadow: none !important;
}

.CancellationPolicies-btnPrimaryBorder-CQ6jp {
  color: var(--btn-primaryBorder-color) !important;
  background-color: var(--btn-primaryBorder-bg) !important;
  padding: 11px 20px;
  font-weight: 500;
  font-size: 18px;
  border-radius: 6px;
  -webkit-box-shadow: none !important;
          box-shadow: none !important;
  text-decoration: none !important;
  border: 1px solid var(--btn-primaryBorder-color) !important;
  cursor: pointer;
  line-height: 24px;
  display: inline-block;
}

.CancellationPolicies-btnPrimaryBorder-CQ6jp:hover,
.CancellationPolicies-btnPrimaryBorder-CQ6jp:focus,
.CancellationPolicies-btnPrimaryBorder-CQ6jp:active,
.CancellationPolicies-btnPrimaryBorder-CQ6jp:active:hover,
.CancellationPolicies-btnPrimaryBorder-CQ6jp:active:focus {
  color: var(--btn-primaryBorder-color) !important;
  background-color: var(--btn-primaryBorder-bg) !important;
  -webkit-box-shadow: none !important;
          box-shadow: none !important;
}

.CancellationPolicies-btnSecondary-aTPYr {
  border: 1px solid var(--btn-secondary-bg) !important;
  background-color: var(--primary-white-bg) !important;
  color: var(--btn-secondary-bg) !important;
  padding: 11px 20px;
  font-weight: 500;
  font-size: 18px;
  line-height: 24px;
  -webkit-box-shadow: none !important;
          box-shadow: none !important;
}

.CancellationPolicies-btnSecondary-aTPYr:hover,
.CancellationPolicies-btnSecondary-aTPYr:focus,
.CancellationPolicies-btnSecondary-aTPYr:active,
.CancellationPolicies-btnSecondary-aTPYr:active:hover,
.CancellationPolicies-btnSecondary-aTPYr:active:focus {
  border-color: var(--btn-secondary-bg) !important;
  background-color: var(--btn-secondary-bg) !important;
  color: var(--white-text) !important;
  -webkit-box-shadow: none !important;
          box-shadow: none !important;
}

.CancellationPolicies-btnPrimaryLink-AJjL9 {
  border: 1px solid var(--btn-primaryBorder-color) !important;
}

.CancellationPolicies-nofocus-U7mfR:active:focus {
  background: var(--primary-white-bg) !important;
  color: var(--btn-primaryBorder-color) !important;
}

.CancellationPolicies-btnSmall-E1PdD {
  padding: 5px 0px;
}

.CancellationPolicies-btnBig-ubE4e {
  padding: 12px 21px !important;
}

.CancellationPolicies-fullWidth-tewzv {
  width: 100%;
}

.CancellationPolicies-WidthAuto-FS_Fs {
  width: auto;
}

.CancellationPolicies-fullHeight-fZ4Ey {
  height: 100%;
}

.CancellationPolicies-noTextDecration-a_MPi {
  text-decoration: none !important;
}

.CancellationPolicies-commonListStyleNone-YgEbD {
  list-style-type: none;
  margin: 0;
  padding: 0;
}

.CancellationPolicies-btnMedium-KO_9Z,
.CancellationPolicies-btnMedium-KO_9Z:hover,
.CancellationPolicies-btnMedium-KO_9Z:focus,
.CancellationPolicies-btnMedium-KO_9Z:focus:hover,
.CancellationPolicies-btnMedium-KO_9Z:active,
.CancellationPolicies-btnMedium-KO_9Z:active:hover {
  padding-inline: 19px !important;
  white-space: normal;
}

.CancellationPolicies-btnMediumSpace-MLMHT,
.CancellationPolicies-btnMediumSpace-MLMHT:hover,
.CancellationPolicies-btnMediumSpace-MLMHT:focus,
.CancellationPolicies-btnMediumSpace-MLMHT:focus:hover,
.CancellationPolicies-btnMediumSpace-MLMHT:active,
.CancellationPolicies-btnMediumSpace-MLMHT:active:hover {
  padding-inline: 19px !important;
  white-space: normal;
}

.CancellationPolicies-btnMediumPadding-NBHWv,
.CancellationPolicies-btnMediumPadding-NBHWv:hover,
.CancellationPolicies-btnMediumPadding-NBHWv:focus,
.CancellationPolicies-btnMediumPadding-NBHWv:active,
.CancellationPolicies-btnMediumPadding-NBHWv:active:hover,
.CancellationPolicies-btnMediumPadding-NBHWv:focus:hover {
  padding: 12px 19px;
}

.CancellationPolicies-aiAskButton-fVPwo {
  padding: 12px 18px;
  border: unset !important;
  outline: unset !important;
  border-radius: 24px 24px 24px 6px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  gap: 6px;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: var(--primary-foreground);
  -webkit-box-shadow: 0px 2px 6px 0px #EA672021 !important;
          box-shadow: 0px 2px 6px 0px #EA672021 !important;
  background: var(--ai-badge-bg) !important;
  position: relative;
  opacity: 1 !important;
}

.CancellationPolicies-aiBadgeStyle-ZWtPC {
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  gap: 4px;
  background: var(--ai-badge-bg);
  border-radius: 100px;
  position: relative;
  -webkit-box-shadow: 0px 2px 6px 0px #EA672021;
          box-shadow: 0px 2px 6px 0px #EA672021;
  font-weight: 500;
  font-size: 18px;
  line-height: 24px;
  padding: 4px 12px;
}

.CancellationPolicies-aiTextColor-sNlw_ {
  background: var(--ai-foreground);
  -webkit-background-clip: text;
          background-clip: text;
  -webkit-text-fill-color: transparent;
}

.CancellationPolicies-aiBadgeStyle-ZWtPC>svg {
  position: relative;
  top: 2px;
}

.CancellationPolicies-aiAskButton-fVPwo::after,
.CancellationPolicies-aiBadgeStyle-ZWtPC::after {
  content: '';
  position: absolute;
  inset: -1px;
  background: var(--ai-border);
  border-radius: inherit;
  z-index: -1;
}

.CancellationPolicies-aiFooterInfoText-iZLFa {
  font-size: 12px;
  line-height: 18px;
  color: var(--secondary-foreground);
  display: inline-block;
  font-weight: 500;
}

.CancellationPolicies-regenerateBtn-siEkL {
  font-size: 16px;
  line-height: 22px;
  font-weight: 500;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  gap: 4px;
  background-color: transparent !important;
  -webkit-box-shadow: none !important;
          box-shadow: none !important;
  border: 0;
  padding: 0px;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
}

.CancellationPolicies-regenerateBtn-siEkL>svg {
  position: relative;
  top: 3px;
}

/************************ text Align ************************/

.CancellationPolicies-textAlignRight-JWsuS {
  text-align: right;
}

.CancellationPolicies-textAlignLeft-dLt2K {
  text-align: left;
}

.CancellationPolicies-textAlignCenter-mynoT {
  text-align: center;
}

/************************ text Align end ******************/

.CancellationPolicies-formControlInput-sgT6r {
  padding: 10px 19px 10px 19px;
  height: 48px;
  border-radius: 6px;
  font-size: 16px;
  border: 1px solid var(--primary-border) !important;
  background-color: var(--primary-white-bg);
  line-height: 24px;
  color: var(--common-text-color);
  font-weight: normal;
  border: 1px solid transparent;
  -webkit-appearance: none !important;
  -webkit-box-shadow: none !important;
          box-shadow: none !important;
}

.CancellationPolicies-formControlSelect-sS68L {
  padding: 10px 35px 10px 19px;
  height: 48px;
  border-radius: 6px;
  font-size: 16px;
  border: 1px solid var(--primary-border) !important;
  background-color: var(--primary-white-bg);
  color: var(--common-text-color);
  line-height: 19px;
  font-weight: normal;
  display: block;
  -moz-appearance: none;
       appearance: none;
  -webkit-appearance: none !important;
  -webkit-box-shadow: none !important;
          box-shadow: none !important;
}

.CancellationPolicies-noTextDecoration-TnrDr {
  text-decoration: none !important;
}

/*-----------------------Profilephoto Upload Common Styles Start----------------------------- */

.CancellationPolicies-picContainerMain-Rq7D8 {
  position: relative;
}

.CancellationPolicies-profilePic-XvzWu {
  height: 100%;
  width: 100%;
  border-radius: 12px;
}

.CancellationPolicies-trashIcon-ZQpez {
  position: absolute;
  top: 2px;
  right: 2px;
  width: 22px;
  height: 22px;
  background: var(--common-background-color);
  padding-top: 3px;
  border: 0;
  border-radius: 2px;
  opacity: .9;
  color: var(--white-text);
  cursor: pointer;
}

.CancellationPolicies-trashIconNew-lIh4M {
  position: absolute;
  top: 18px;
  right: 18px;
}

.CancellationPolicies-trashIconNew-lIh4M img {
  width: 36px;
}

.CancellationPolicies-bannerImageBg-UTDia {
  width: 100%;
  height: 100%;
  min-height: 179px;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: 50% 50%;
  position: relative;
  border-radius: 0px;
}

.CancellationPolicies-profileImageBg-ylxph {
  padding-top: 36%;
  background-repeat: no-repeat;
  background-size: contain;
  width: 100%;
  height: 100%;
  max-width: 180px;
  margin: 0 auto;
  background-position: 50% 50%;
  background-size: 66px;
}

.CancellationPolicies-whiteImg-AC4rm {
  background: var(--modalText-color);
  border-radius: 0px;
}

.CancellationPolicies-curserPointer-yHQPV {
  cursor: pointer;
}

.CancellationPolicies-adminLabelTextNew-ih8kw {
  font-size: 18px;
  font-weight: 500;
  color: var(--common-text-color);
}

/*-----------------------Profilephoto Upload Common Styles End----------------------------- */

/******************* Admin Modal ListSetting Start *******************/

.CancellationPolicies-radioBtn-gvbeL {
  position: relative;
  top: 1px;
  vertical-align: middle;
  margin-left: 3px;
}

.CancellationPolicies-displayinlineBlock-QluI1 {
  display: inline-block;
}

.CancellationPolicies-displayBlock-baVVg {
  display: block;
}

.CancellationPolicies-displayFlex-Jsw0h {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
}

.CancellationPolicies-inlineDisplayFlex-D6zvp {
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
}

.CancellationPolicies-alignCenter-XuWfp {
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
}

.CancellationPolicies-spaceBetween-UK7ZN {
  -webkit-box-pack: justify;
      -ms-flex-pack: justify;
          justify-content: space-between;
}

.CancellationPolicies-alignItemFlexStart-VNXvH {
  -webkit-box-align: start;
      -ms-flex-align: start;
          align-items: flex-start;
}

/******************* Admin Modal ListSetting Start *******************/

.CancellationPolicies-commonTitleText-COX9Z {
  font-size: 36px;
  margin: 0px;
  word-wrap: break-word;
}

.CancellationPolicies-commonSubTitleText-cBEe7 {
  font-size: 20px;
  margin: 0px;
}

.CancellationPolicies-commonContentText-oJ7Tw {
  font-size: 18px;
  margin: 0px;
}

.CancellationPolicies-commonMediumText-yXC4p {
  font-size: 16px;
  margin: 0px;
}

.CancellationPolicies-commonTotalText-Xcof7 {
  font-size: 24px;
  margin: 0px;
}

.CancellationPolicies-commonSmallText-Laplp {
  font-size: 14px;
  margin: 0px;
}

.CancellationPolicies-fontWeightExtraBold-nPvOV {
  font-weight: 700;
}

.CancellationPolicies-fontWeightBold-EE2Dj {
  font-weight: 600;
}

.CancellationPolicies-fontWeightMedium-pyKv2 {
  font-weight: 500;
}

.CancellationPolicies-fontWeightNormal-e7bl4 {
  font-weight: 400;
}

.CancellationPolicies-textDecorationUnderLine-FcIIO {
  text-decoration: underline;
}

.CancellationPolicies-textDecorationNone-ee3Om {
  text-decoration: none !important;
}

.CancellationPolicies-siteLinkColor-Znln2,
.CancellationPolicies-siteLinkColor-Znln2:hover,
.CancellationPolicies-siteLinkColor-Znln2:focus,
.CancellationPolicies-siteLinkColor-Znln2:active {
  color: var(--common-link-color);
}

.CancellationPolicies-commonLinkBorderBottom-uKcga {
  border-bottom: 1px solid var(--common-link-color);
}

.CancellationPolicies-siteTextColor-TqesO,
.CancellationPolicies-siteTextColor-TqesO:hover,
.CancellationPolicies-siteTextColor-TqesO:focus,
.CancellationPolicies-siteTextColor-TqesO:active {
  color: var(--common-text-color);
}

.CancellationPolicies-positionRelative-mcbp8 {
  position: relative;
}

.CancellationPolicies-listingHorizoltalLine-SnFCj {
  margin: 40px 0px;
  border-top: 1px solid var(--primary-border);
}

/******************************* Common Margin Start *****************************/

.CancellationPolicies-spaceBottom0-EUCFW {
  margin-bottom: 0px;
}

.CancellationPolicies-spaceBottom1-wjP65 {
  margin-bottom: 6px;
}

.CancellationPolicies-spaceBottom2-L4bL4 {
  margin-bottom: 12px;
}

.CancellationPolicies-spaceBottom3-Iayvl {
  margin-bottom: 18px;
}

.CancellationPolicies-spaceBottom4-ueVd4 {
  margin-bottom: 24px;
}

.CancellationPolicies-spaceBottom5-br1rF {
  margin-bottom: 30px;
}

.CancellationPolicies-spaceBottom6-nOLGr {
  margin-bottom: 36px;
}

.CancellationPolicies-spaceBottom7-Gv31S {
  margin-bottom: 42px;
}

.CancellationPolicies-spaceBottom8-i30ug {
  margin-bottom: 10px;
}

.CancellationPolicies-spaceTop0-R9sxa {
  margin-top: 0px;
}

.CancellationPolicies-spaceTop1-Nxo5t {
  margin-top: 6px;
}

.CancellationPolicies-spaceTop2-ZuH2Y {
  margin-top: 12px;
}

.CancellationPolicies-spaceTop3-UlLZs {
  margin-top: 18px;
}

.CancellationPolicies-spaceTop4-fQi4o {
  margin-top: 24px;
}

.CancellationPolicies-spaceTop5-BAHMa {
  margin-top: 30px;
}

.CancellationPolicies-spaceTop6-xYAsV {
  margin-top: 36px;
}

.CancellationPolicies-spaceTop7-u5RSR {
  margin-top: 42px;
}

.CancellationPolicies-paddingBottom1-mL18R {
  padding-bottom: 6px;
}

.CancellationPolicies-paddingBottom2-OX_Ry {
  padding-bottom: 12px;
}

.CancellationPolicies-paddingBottom3-CS_xX {
  padding-bottom: 18px;
}

.CancellationPolicies-paddingBottom4-NyPw3 {
  padding-bottom: 24px;
}

.CancellationPolicies-paddingBottom5-rLOhX {
  padding-bottom: 30px;
}

.CancellationPolicies-paddingBottom6-YzWdA {
  padding-bottom: 36px;
}

.CancellationPolicies-paddingBottom7-TGKvc {
  padding-bottom: 42px;
}

.CancellationPolicies-paddingTop1-Uivja {
  padding-top: 6px;
}

.CancellationPolicies-paddingTop2-PdfWy {
  padding-top: 12px;
}

.CancellationPolicies-paddingTop3-kCcDi {
  padding-top: 18px;
}

.CancellationPolicies-paddingTop4-GZOOO {
  padding-top: 24px;
}

.CancellationPolicies-paddingTop5-kYokh {
  padding-top: 30px;
}

.CancellationPolicies-paddingTop6-M0Uyz {
  padding-top: 36px;
}

.CancellationPolicies-paddingTop7-fh0Mx {
  padding-top: 42px;
}

.CancellationPolicies-spaceRight1-Hat72 {
  margin-right: 6px;
}

.CancellationPolicies-spaceRight2-Dv20a {
  margin-right: 12px;
}

.CancellationPolicies-spaceRight3-eFwPs {
  margin-right: 18px;
}

.CancellationPolicies-spaceRight4-Yt_8H {
  margin-right: 24px;
}

.CancellationPolicies-paddingBottom8-pTYgE {
  padding-bottom: 15px;
}

.CancellationPolicies-spaceTop8-o_7yp {
  margin-top: 16px;
}

.CancellationPolicies-paddingBottomNone-t4QjJ {
  padding-bottom: 0;
}

.CancellationPolicies-spaceBottom9-jkzq_ {
  margin-bottom: 16px;
}

.CancellationPolicies-spaceBottom10-FHFWP {
  margin-bottom: 17px;
}

.CancellationPolicies-spaceBottom11-mWiWZ {
  margin-bottom: 7px;
}

.CancellationPolicies-spaceBottom12-d8Q2Z {
  margin-bottom: 20px;
}

.CancellationPolicies-noPadding-XAWvI {
  padding: 0px;
}

.CancellationPolicies-flexShrinkNone-VQXW0 {
  -ms-flex-negative: 0;
      flex-shrink: 0;
}

/******************************* Common Margin And Padding End *****************************/

.CancellationPolicies-viewListIcon-oEicd {
  width: 100%;
  max-width: 35px;
  min-width: 35px;
}

.CancellationPolicies-blueLeftArrow-fVEKN {
  padding-left: 6px;
  position: relative;
}

.CancellationPolicies-profileAvatarLink-pBD2p {
  border: 2.5px solid var(--common-link-color);
  border-radius: 50%;
  display: inline-block;
  padding: 7px;
  background-color: var(--dashBoard-info-bg);
}

.CancellationPolicies-profileAvatarLinkSmall-n5jFP {
  padding: 2px
}

.CancellationPolicies-errorMessage-LC0XB {
  margin-top: 5px;
  margin-bottom: 5px;
  display: block;
  color: var(--alert-color);
  font-size: 14px;
  font-weight: normal;
  /* margin-left: 5px; */
}

.CancellationPolicies-textTransformLowerCase-e0NG1 {
  text-transform: lowercase;
}

.CancellationPolicies-passwordIcon-SrQIq {
  position: absolute;
  right: 18px;
  top: 43px;
  cursor: pointer;
}

.CancellationPolicies-noMargin-gom_8 {
  margin: 0px;
}

.CancellationPolicies-noMarginBottom-t4QGK {
  margin-bottom: 0 !important;
}

.CancellationPolicies-dotCss-iUbqR {
  width: 4px;
  height: 4px;
  background: var(--common-background-color);
  border-radius: 50%;
  margin: 0px 4px;
  display: inline-block;
  position: relative;
  top: -3px;
}

.CancellationPolicies-dateArrowMargin-W3L3Y {
  margin: 0px 8px;
}

.CancellationPolicies-commonBorderSection-dt9c7 {
  --wrapper-Padding: 24px;
  border: 1px solid var(--primary-border);
  padding: 18px var(--wrapper-Padding);
  border-radius: 12px;
}

.CancellationPolicies-vtrMiddle-adCMw {
  vertical-align: middle;
}

.CancellationPolicies-positionAvatar-ZW5VG {
  position: absolute;
  top: 15px;
  right: 15px;
}

/* display flex properties */

.CancellationPolicies-dFlex-anA_V {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  display: -webkit-flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
}

.CancellationPolicies-flexWrap-mJCOo {
  -ms-flex-wrap: wrap;
      flex-wrap: wrap;
}

.CancellationPolicies-dInlineFlex-Vr9oC {
  display: inline-block;
  display: -webkit-inline-box;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
}

.CancellationPolicies-dFlexContainer-vm3dw {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  display: -webkit-flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: justify;
      -ms-flex-pack: justify;
          justify-content: space-between;
}

.CancellationPolicies-dFlexWrap-Q_z1E {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  display: -webkit-flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -ms-flex-wrap: wrap;
      flex-wrap: wrap;
  -webkit-flex-wrap: wrap;
}

.CancellationPolicies-dFlexWrapAlignEnd-eZuSU {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  display: -webkit-flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: end;
      -ms-flex-pack: end;
          justify-content: flex-end;
}

.CancellationPolicies-dFlexWrapAlignStart-gAgY_ {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  display: -webkit-flex;
  -ms-flex-wrap: wrap;
      flex-wrap: wrap;
  -webkit-flex-wrap: wrap;
  -webkit-box-align: start;
      -ms-flex-align: start;
          align-items: flex-start;
}

.CancellationPolicies-justifyContentSpaceBetween-WlCe1 {
  -webkit-box-pack: justify;
      -ms-flex-pack: justify;
          justify-content: space-between;
}

.CancellationPolicies-greyText-gSlZe {
  color: var(--modalText-color);
}

.CancellationPolicies-tripsReservationPanel-UVRkB {
  border-radius: 12px;
  width: 100%;
  display: block;
  border: 1px solid var(--primary-border);
  background: var(--primary-white-bg);
  padding: 15px 24px 24px 24px;
}

.CancellationPolicies-listContainer-ElS39 {
  margin: 0px;
  padding: 0px;
  list-style: none;
  border-bottom: 1px solid var(--primary-border);
}

.CancellationPolicies-listTabItem-Iss1E {
  display: block;
  padding: 0px 0px 7px;
  position: relative;
  text-align: center;
  font-size: 18px;
  color: var(--modalText-color);
  cursor: pointer;
  border-bottom: 1px solid transparent;
  margin-right: 30px;
}

.CancellationPolicies-listTabItem-Iss1E:hover,
.CancellationPolicies-listTabItem-Iss1E:active,
.CancellationPolicies-listTabItem-Iss1E:focus,
.CancellationPolicies-listTabItem-Iss1E:active:hover,
.CancellationPolicies-listTabItem-Iss1E:focus:hover {
  text-decoration: none;
  color: var(--common-text-color);
}

.CancellationPolicies-reviewsContainer-cXYSL {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: start;
      -ms-flex-align: start;
          align-items: flex-start;
  -webkit-column-gap: 6px;
     -moz-column-gap: 6px;
          column-gap: 6px;
}

.CancellationPolicies-reviewsYourItemsOne-ku_hI {
  -webkit-box-flex: 1;
  -ms-flex: 1 0 auto;
  flex: 1 0 auto;
}

.CancellationPolicies-reviewsYourItemsTwo-ogqbv {
  -webkit-box-flex: 1;
  -ms-flex: 1 1 100%;
  flex: 1 1 100%;
}

.CancellationPolicies-rightBg-ttV5X {
  background: var(--common-gray-bg-color);
  border-radius: 0 8px 8px 8px;
  padding: 16px 18px 18px 18px;
  width: 100%;
  position: relative;
  -webkit-border-radius: 0 8px 8px 8px;
  -moz-border-radius: 0 8px 8px 8px;
  -ms-border-radius: 0 8px 8px 8px;
  -o-border-radius: 0 8px 8px 8px;
}

.CancellationPolicies-commonProfileAvatarLink-qKOBn {
  -webkit-backface-visibility: hidden;
          backface-visibility: hidden;
  position: relative;
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  width: 68px;
  height: 68px;
  overflow: hidden;
  border-radius: 50%;
  border: 2px solid var(--common-link-color);
  background-color: transparent;
  padding: 3px;
  position: relative;
  z-index: 5;
}

.CancellationPolicies-commonProfileAvatarLink-qKOBn img {
  width: 100%;
  height: 100%;
  -o-object-fit: contain;
     object-fit: contain;
  background-color: var(--primary-white-bg);
  border-radius: 50%;
}

.CancellationPolicies-writtenReviewTitle-pt5js {
  font-weight: 500;
  margin-bottom: 6px;
  word-break: break-word;
  color: var(--common-text-color);
  font-size: 18px;
}

.CancellationPolicies-reviewTitleLink-xluCj {
  color: var(--common-link-color);
  font-weight: 500;
}

.CancellationPolicies-reviewTitleLink-xluCj:hover,
.CancellationPolicies-reviewTitleLink-xluCj:focus,
.CancellationPolicies-reviewTitleLink-xluCj:active,
.CancellationPolicies-reviewTitleLink-xluCj:active:hover {
  color: var(--common-link-color);

}

.CancellationPolicies-reviewFlex-SzW_i {
  -webkit-column-gap: 5px;
     -moz-column-gap: 5px;
          column-gap: 5px;
  font-size: 14px;
  color: var(--common-text-color);
  margin-bottom: 6px;
  -ms-flex-wrap: wrap;
      flex-wrap: wrap;
}

.CancellationPolicies-noTop-SxI1S {
  top: 0;
}

.CancellationPolicies-reviewPara-qOeD5 {
  color: var(--common-text-color);
  word-break: break-word;
}

.CancellationPolicies-dFlexColumn-Zd5ot {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
      -ms-flex-direction: column;
          flex-direction: column;
}

.CancellationPolicies-commonlineCss-R8Mxo {
  margin: 18px 0;
  border: 1px solid var(--primary-border);
}

.CancellationPolicies-rightBg-ttV5X::after {
  content: "";
  position: absolute;
  left: -38px;
  top: 0;
  right: auto;
  width: 38px;
  height: 40px;
  background: var(--primary-white-bg);
  border-top-right-radius: 30px;
  border-bottom-left-radius: 30px;
  z-index: 3;
}

.CancellationPolicies-rightBg-ttV5X::before {
  content: " ";
  position: absolute;
  display: inline-block;
  width: 0;
  height: 0;
  bottom: auto;
  border: 10px solid transparent;
  border-left: 0;
  border-right-color: var(--primary-white-bg);
  top: 0;
  left: auto;
  right: 100%;
  border-width: 0 24px 24px 0;
  border-color: transparent #F9F9F9 transparent transparent;
}

.CancellationPolicies-loadBtn-kyuSs {
  border-color: var(--btn-primary-bg);
  color: var(--white-text);
  height: 48px;
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  background: var(--btn-primary-bg);
  border-radius: 6px;
  padding: 12px 19px;
  font-size: 18px;
  font-weight: 500;
  cursor: pointer;
}

.CancellationPolicies-loadBtn-kyuSs:hover,
.CancellationPolicies-loadBtn-kyuSs:active,
.CancellationPolicies-loadBtn-kyuSs:focus,
.CancellationPolicies-loadBtn-kyuSs:active:hover,
.CancellationPolicies-loadBtn-kyuSs:active:focus,
.CancellationPolicies-loadBtn-kyuSs[disabled]:hover,
.CancellationPolicies-loadBtn-kyuSs[disabled]:focus {
  color: var(--white-text);
  border-color: var(--btn-primary-bg);
  background: var(--btn-primary-bg);
}

.CancellationPolicies-vtrTop-wDpGC {
  vertical-align: top;
}

.CancellationPolicies-reviewHeadingColor-fCxaV {
  color: var(--common-text-color);
}

.CancellationPolicies-reviewWriteHeading-bECBG {
  font-weight: 500;
  word-break: break-word;
  color: var(--common-text-color);
  font-size: 18px;
}

.CancellationPolicies-noDataImgSize-lXtUl {
  width: 100%;
  height: 100%;
  -o-object-fit: contain;
     object-fit: contain;
}

.CancellationPolicies-justifyCenter-XZ7FR {
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
}

.CancellationPolicies-btnTextBrk-ZuysL {
  white-space: normal;
  word-break: break-word;
}

.CancellationPolicies-marginInlineAuto-AgcrJ {
  margin-inline: auto;
}

.CancellationPolicies-noItemPanel-DeoV1 {
  background: var(--primary-white-bg);
  border-radius: 12px;
  border: 1px solid var(--primary-border);
  padding: 44px 0;
}

.CancellationPolicies-textLineBreak-_wktl {
  word-break: break-word;
}

.CancellationPolicies-displayBlock-baVVg {
  display: block;
}

.CancellationPolicies-displayInlineBlock-AQSsk {
  display: inline-block;
}

.CancellationPolicies-commonContainerList-mHz1L {
  width: 100%;
  max-width: var(--max-listing-width);
  margin: 0 auto;
}

.CancellationPolicies-adminBorderWithoutPadding-g8JoW {
  border: 1px solid var(--primary-border);
  border-radius: 4px;
}

.CancellationPolicies-marginRight8-DWrOn {
  margin-right: 8px;
}

.CancellationPolicies-adminDotIconBtn-e75hj,
.CancellationPolicies-adminDotIconBtn-e75hj:hover,
.CancellationPolicies-adminDotIconBtn-e75hj:focus,
.CancellationPolicies-adminDotIconBtn-e75hj:active {
  border: none;
  background-color: transparent !important;
  -webkit-box-shadow: none !important;
          box-shadow: none !important;
}

.CancellationPolicies-commonLinkBorder-zsH76 {
  border-bottom: 1px solid var(--common-link-color);
}

.CancellationPolicies-commonTabelDropDownBg-JO5Uw {
  background: var(--common-gray-bg-color);
  -webkit-box-shadow: 0px 3px 6px #00000029;
          box-shadow: 0px 3px 6px #00000029;
  border-radius: 6px;
  padding: 10px;
}

.CancellationPolicies-tabelDropDownBtn-CNTvx,
.CancellationPolicies-tabelDropDownBtn-CNTvx:hover,
.CancellationPolicies-tabelDropDownBtn-CNTvx:active,
.CancellationPolicies-tabelDropDownBtn-CNTvx:focus {
  padding: 12px 10px !important;
  border: none;
  -webkit-box-shadow: none !important;
          box-shadow: none !important;
  background-color: transparent !important;
  font-size: 16px;
  color: var(--common-text-color);
  line-height: inherit;
  vertical-align: top;
  border-radius: 0;
}

.CancellationPolicies-tableHorizantalLine-IkrDo {
  border-color: var(--primary-border);
  margin: 6px 0px;
}

.CancellationPolicies-backArrowStyle-XKYGh {
  width: 15px;
  height: 12px;
  margin-right: 6px;
}

.CancellationPolicies-csvImageSpace-hpDhq {
  margin: 0px 6px;
}

.CancellationPolicies-flexEnd-rOttG {
  -webkit-box-align: end;
      -ms-flex-align: end;
          align-items: flex-end;
}

.CancellationPolicies-justifyContentFlexEnd-SeLW1 {
  -webkit-box-pack: end;
      -ms-flex-pack: end;
          justify-content: flex-end;
}

.CancellationPolicies-profileAvatarLinkPayment-_kAkW {
  padding: 5px;
}

.CancellationPolicies-alignItemBaseline-rv0Ie {
  -webkit-box-align: baseline;
      -ms-flex-align: baseline;
          align-items: baseline;
}

.CancellationPolicies-payOutToolTip-YiCX7 {
  margin: 0 3px;
}

.CancellationPolicies-tolltipMargin-zc9hX {
  margin: 0 3px;
}

.CancellationPolicies-textNoWrap-_aBgd {
  white-space: nowrap;
}

.CancellationPolicies-commonSearchInputFilterContainer-UyFcM {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  gap: 16px;
  grid-gap: 16px;
  -webkit-box-flex: 1;
      -ms-flex-positive: 1;
          flex-grow: 1;
}

.CancellationPolicies-mobileTableSearch-CUbqO {
  margin-bottom: 24px;
  gap: 16px;
  grid-gap: 16px;
  -ms-flex-wrap: wrap;
      flex-wrap: wrap;
}

.CancellationPolicies-mobileTableOnlyLink-iIaiI {
  -webkit-box-pack: end;
      -ms-flex-pack: end;
          justify-content: flex-end;
}

.CancellationPolicies-linkBtnPrimaryStyle-FxxGF {
  background-color: transparent !important;
  color: var(--common-link-color);
  padding: 0;
  border: unset;
  -webkit-box-shadow: unset !important;
          box-shadow: unset !important;
  border-bottom: 1px solid var(--common-link-color);
  font-weight: 500;
  font-size: 18px;
  text-decoration: none;
  line-height: 26px;
  border-radius: 0 !important;
  white-space: normal;
}

.CancellationPolicies-linkBtnPrimaryStyle-FxxGF:hover,
.CancellationPolicies-linkBtnPrimaryStyle-FxxGF:focus,
.CancellationPolicies-linkBtnPrimaryStyle-FxxGF:active,
.CancellationPolicies-linkBtnPrimaryStyle-FxxGF:active:hover {
  color: var(--common-link-color);
  border-bottom: 1px solid var(--common-link-color);
}

.CancellationPolicies-dataTableGrid-NdGMD {
  display: grid;
  grid-template-columns: 3fr 2fr;
  gap: 4px;
}

.CancellationPolicies-paymentDivider-RbmWy {
  border-bottom: 1px solid var(--primary-border);
  padding-bottom: 12px;
  margin-bottom: 12px;
}

.CancellationPolicies-paymentDivider-RbmWy:last-child {
  border-bottom: unset;
  margin-bottom: 0;
  padding-bottom: 0;
}

.CancellationPolicies-bulletList-URpsQ {
  list-style: disc;
  -webkit-padding-start: 25px;
          padding-inline-start: 25px;
}

.CancellationPolicies-commonSmallText14-aUtwZ {
  font-size: 14px;
  line-height: 20px;
}

.CancellationPolicies-commonSmallText16-I_5Rw {
  font-size: 16px;
  line-height: 22px;
}

.CancellationPolicies-commonSmallText18-X026L {
  font-size: 18px;
  line-height: 24px;
}

.CancellationPolicies-commonSmallText20-EX2VG {
  font-size: 20px;
  line-height: 26px;
}

.CancellationPolicies-commonSmallText24-T3TEg {
  font-size: 24px;
  line-height: 30px;
}

.CancellationPolicies-commonSmallText26-rw45L {
  font-size: 26px;
  line-height: normal;
}

.CancellationPolicies-top1-b8RlY {
  top: 1px;
}

.CancellationPolicies-top2-roKN1 {
  top: 2px;
}

.CancellationPolicies-top3-dljRQ {
  top: 3px
}

.CancellationPolicies-topMinus1-bI9Rj {
  top: -1px;
}

.CancellationPolicies-topMinus2-c_VeI {
  top: -2px;
}

.CancellationPolicies-topMinus3-f7uea {
  top: -3px
}

.CancellationPolicies-textEnd-u6PlR {
  text-align: end;
}

.CancellationPolicies-textAlignCenter-mynoT {
  text-align: center;
}

.CancellationPolicies-textStart-bZVnE {
  text-align: start;
}

.CancellationPolicies-flexGrow-TjZ0u {
  -webkit-box-flex: 1;
      -ms-flex-positive: 1;
          flex-grow: 1;
}

/* dropzone */

.CancellationPolicies-imageUploadDropzoneSection-zTHFV {
  border-radius: 12px;
  width: 100%;
  height: 180px;
  position: relative;
}

.CancellationPolicies-imageUploadDropzoneSectionOutline-qU0S8 {
  background-color: var(--secondary-gray-bg);
  border: 2px dashed var(--primary-border);
}

.CancellationPolicies-commonDropZoneImgContainer-JrbRV {
  position: absolute;
  inset: 0;
  -o-object-fit: contain;
     object-fit: contain;
  width: 100%;
  height: 100%;
  background-repeat: no-repeat;
  -o-object-position: center;
     object-position: center;
  background-size: contain;
  background-position: center;
}

.CancellationPolicies-commonDropZoneDefaultImg-A7S0o {
  background-size: 70px 70px;
}

.CancellationPolicies-navTabFlex-rZW2k {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  gap: 12px 30px;
  border-bottom: 1px solid var(--primary-border);
  list-style: none;
  padding: 0;
  margin: 0 0 24px;
}

.CancellationPolicies-navTabLink-lPw3q {
  font-size: 18px;
  line-height: 24px;
  color: var(--tertiary-foreground) !important;
  padding-bottom: 6px;
  text-decoration: none !important;
  position: relative;
  text-align: center;
  display: block;
  cursor: pointer;
}

.CancellationPolicies-navTabLink-lPw3q.CancellationPolicies-activeTabStyle-CeJkM {
  color: var(--primary-foreground) !important;
  font-weight: 500;
}

.CancellationPolicies-navTabLink-lPw3q.CancellationPolicies-activeTabStyle-CeJkM::after {
  content: "";
  position: absolute;
  width: 100%;
  height: 1px;
  background-color: var(--primary-link-foreground) !important;
  bottom: -1px;
  left: 0;
  right: 0;
}

.CancellationPolicies-listingCardCarTypeAndTransmissionLabelFlexContainer-drJjW {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  font-size: 14px;
  color: var(--primary-foreground);
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
}

.CancellationPolicies-listingCardCarTypeAndTransmissionLabelFlexContainer-drJjW>div {
  max-width: 50%;
}

.CancellationPolicies-transmissionLabelText-ABeke {
  position: relative;
  -webkit-padding-start: 15px;
          padding-inline-start: 15px;
}

.CancellationPolicies-transmissionLabelText-ABeke::before {
  content: '';
  position: absolute;
  width: 4px;
  height: 4px;
  background: var(--common-background-color);
  border-radius: 50%;
  left: 5px;
  top: 8px;
}

.CancellationPolicies-carTypeIcon-Kjw6S {
  position: relative;
  top: -2px;
}

.CancellationPolicies-textFlow-AlRL3 {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

@media screen and (min-width:992px) {
  .CancellationPolicies-paymentSticky-Dlufb {
    position: sticky !important;
    position: -webkit-sticky;
    top: 42px
  }
}

@media (max-width: 1024px) and (min-width: 768px) {
  .CancellationPolicies-dateArrowMargin-W3L3Y {
    margin: 0px -10px;
  }
}

@media screen and (max-width: 767px) {
  .CancellationPolicies-btnWidth-QN77E {
    width: 100%;
  }

  .CancellationPolicies-mobTextCenter-_XzAc {
    text-align: center !important;
  }

  .CancellationPolicies-tripsReservationPanel-UVRkB {
    padding-inline: 15px;
  }

  .CancellationPolicies-listContainer-ElS39 {
    border-bottom: unset;
    -ms-flex-wrap: wrap;
        flex-wrap: wrap;
  }

  .CancellationPolicies-listContainer-ElS39 li .CancellationPolicies-listTabItem-Iss1E {
    margin-right: 0;
    margin-left: 0;
  }

  .CancellationPolicies-writtenReviewTitle-pt5js,
  .CancellationPolicies-reviewTitleLink-xluCj {
    font-size: 16px;
  }

  .CancellationPolicies-reviewFlex-SzW_i {
    font-size: 12px;
  }

  .CancellationPolicies-reviewPara-qOeD5 {
    font-size: 14px;
  }

  .CancellationPolicies-commonProfileAvatarLink-qKOBn {
    width: 50px;
    height: 50px;
  }

  .CancellationPolicies-reviewWriteHeading-bECBG {
    font-size: 16px;
  }

  .CancellationPolicies-mobileReviewIconBox-SZ93H {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
        -ms-flex-direction: column;
            flex-direction: column;
    -webkit-box-align: start;
        -ms-flex-align: start;
            align-items: flex-start;
  }

  .CancellationPolicies-mrMarginBottom-ffROL {
    margin-bottom: 5px;
  }

  .CancellationPolicies-mrRemoveMargin-ZGh5L {
    margin-right: 0;
  }

  .CancellationPolicies-mrListDeletBtnBox-M8KgG {
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
        -ms-flex-direction: column;
            flex-direction: column;
  }

  .CancellationPolicies-mobileFlexContainer-k0hFb {
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
        -ms-flex-direction: column;
            flex-direction: column;
  }

  .CancellationPolicies-mobileFlexContainer-k0hFb li {
    display: block;
    width: 100%;
    margin-bottom: 10px;
  }

  .CancellationPolicies-mobileDisplayBlock-ATdKL {
    display: block;
  }

  .CancellationPolicies-mobileTextCenter-Msg54 {
    text-align: center;
  }

  .CancellationPolicies-profileImageBg-ylxph,
  .CancellationPolicies-bannerImageBg-UTDia {
    padding-top: 60%;
  }

  .CancellationPolicies-trashIconNew-lIh4M {
    top: 12px;
    right: 12px;
  }

  .CancellationPolicies-mobileTableSearch-CUbqO {
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
        -ms-flex-direction: column;
            flex-direction: column;
    -webkit-box-align: start;
        -ms-flex-align: start;
            align-items: flex-start;
  }

  .CancellationPolicies-commonBorderSection-dt9c7 {
    --wrapper-Padding: 18px;
  }

  .CancellationPolicies-commonSearchInputFilterContainer-UyFcM {
    width: 100%;
    -ms-flex-wrap: wrap;
        flex-wrap: wrap;
  }

  .CancellationPolicies-mobileTableOnlyLink-iIaiI {
    -webkit-box-align: end;
        -ms-flex-align: end;
            align-items: flex-end;
  }

  .CancellationPolicies-navTabFlex-rZW2k {
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
        -ms-flex-direction: column;
            flex-direction: column;
    -webkit-box-align: stretch;
        -ms-flex-align: stretch;
            align-items: stretch;
    border: unset;
  }
}

.CancellationPolicies-displayGrid-WNP2L {
  display: grid;
}

.CancellationPolicies-gridCols2-frTNJ {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.CancellationPolicies-gap4-yDOpv {
  gap: 4px;
}

.CancellationPolicies-gap6-hfbRi {
  gap: 6px;
}

.CancellationPolicies-gap8-yHTsp {
  gap: 8px;
}

.CancellationPolicies-gap12-HfHWo {
  gap: 12px;
}

.CancellationPolicies-gap16-Ssk7O {
  gap: 16px;
}

.CancellationPolicies-gap24-mdexX {
  gap: 24px;
}

.CancellationPolicies-columnGap16-Sjs8u {
  -webkit-column-gap: 16px;
     -moz-column-gap: 16px;
          column-gap: 16px;
}

.CancellationPolicies-rowGap18-NxgNN {
  row-gap: 18px;
}

.CancellationPolicies-bt-pRyY3 {
  border-top: 1px solid var(--primary-border);
}

.CancellationPolicies-languageBox-nI0mm>div:not(:first-child) {
  padding-top: 24px;
  border-top: 1px solid var(--primary-border);
  margin-top: 24px;
}

.CancellationPolicies-languageBtnContainerOne-jqJw4 {
  margin-bottom: 24px;
}

.CancellationPolicies-languageBox-nI0mm>div:last-child .CancellationPolicies-languageBtnContainerOne-jqJw4 {
  margin-bottom: 0;
}

.CancellationPolicies-commonInputGrpDivider-Rt4ZZ {
  padding-bottom: 18px;
  border-bottom: 1px solid var(--primary-border);
}

@media screen and (max-width: 991px) {
  .CancellationPolicies-gridColsTab1-gtQvl {
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }

  .CancellationPolicies-gapTab0-it4KK {
    gap: 0px !important;
  }
}

@media screen and (max-width: 767px) {
  .CancellationPolicies-gridColsMobile1-Dayfd {
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }

  .CancellationPolicies-mobileFlexColumn-D70ZX {
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
        -ms-flex-direction: column;
            flex-direction: column;
  }

  .CancellationPolicies-mobileAlignFlexStretch-kW4j2 {
    -webkit-box-align: stretch;
        -ms-flex-align: stretch;
            align-items: stretch;
  }
}

.CancellationPolicies-landingContainer-FfNF9 {
	max-width: 1080px;
	width: 100%;
	display: block;
	margin: 0 auto;
}

.CancellationPolicies-cancellationBg-gGFxI {
	padding: 26px 30px 30px 30px;
	border-radius: 12px;
	border: 1px solid var(--primary-border);
}

.CancellationPolicies-cancelCard-Y7G1B {
	-webkit-box-shadow: 0px 4px 6px #EAEAEA29;
	        box-shadow: 0px 4px 6px #EAEAEA29;
	border-radius: 8px;
	padding: 24px;
}

.CancellationPolicies-cancelCardOne-_mRCb {
	background: var(--cancel-bg-one);
}

.CancellationPolicies-cancelCardTwo-qUHmb {
	background: var(--cancel-bg-two);
}

.CancellationPolicies-cancelCardThree-bn48Z {
	background: var(--cancel-bg-three);
}

.CancellationPolicies-cancelDescSec-d4doZ {
	padding: 24px;
	background: var(--common-gray-bg-color);
	border-radius: 8px;
}

.CancellationPolicies-horizontalLine-Gr73t {
	background: var(--primary-border);
	margin-top: 18px;
	margin-bottom: 18px;
}

.CancellationPolicies-descListSpaceLeft-kp9Tk {
	padding-left: 20px;
}

@media screen and (max-width: 767px) {
	.CancellationPolicies-pageTitle-Wg6rB {
		font-size: 25px;
	}

	.CancellationPolicies-cancellationBg-gGFxI,
	.CancellationPolicies-cancelCard-Y7G1B,
	.CancellationPolicies-cancelDescSec-d4doZ {
		padding: 17px;
	}
}`, "",{"version":3,"sources":["webpack://./src/components/commonStyle.css","webpack://./src/components/CancellationPolicies/CancellationPolicies.css"],"names":[],"mappings":"AAAA;EACE,8CAA8C;EAC9C,kDAAkD;EAClD,0CAA0C;EAC1C,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,mCAA2B;UAA3B,2BAA2B;EAC3B,gCAAgC;EAChC,eAAe;EACf,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;;;;;;;EAOE,oDAAoD;EACpD,wDAAwD;EACxD,0CAA0C;EAC1C,mCAA2B;UAA3B,2BAA2B;AAC7B;;AAEA;EACE,gDAAgD;EAChD,wDAAwD;EACxD,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,mCAA2B;UAA3B,2BAA2B;EAC3B,gCAAgC;EAChC,2DAA2D;EAC3D,eAAe;EACf,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;;;;;EAKE,gDAAgD;EAChD,wDAAwD;EACxD,mCAA2B;UAA3B,2BAA2B;AAC7B;;AAEA;EACE,oDAAoD;EACpD,oDAAoD;EACpD,yCAAyC;EACzC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,mCAA2B;UAA3B,2BAA2B;AAC7B;;AAEA;;;;;EAKE,gDAAgD;EAChD,oDAAoD;EACpD,mCAAmC;EACnC,mCAA2B;UAA3B,2BAA2B;AAC7B;;AAEA;EACE,2DAA2D;AAC7D;;AAEA;EACE,8CAA8C;EAC9C,gDAAgD;AAClD;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,qBAAqB;EACrB,SAAS;EACT,UAAU;AACZ;;AAEA;;;;;;EAME,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA;;;;;;EAME,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA;;;;;;EAME,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,yBAAyB;EACzB,iCAAiC;EACjC,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,gCAAgC;EAChC,wDAAgD;UAAhD,gDAAgD;EAChD,yCAAyC;EACzC,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,2BAAoB;EAApB,2BAAoB;EAApB,oBAAoB;EACpB,QAAQ;EACR,8BAA8B;EAC9B,oBAAoB;EACpB,kBAAkB;EAClB,6CAAqC;UAArC,qCAAqC;EACrC,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,gCAAgC;EAChC,6BAAqB;UAArB,qBAAqB;EACrB,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,QAAQ;AACV;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,4BAA4B;EAC5B,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,kCAAkC;EAClC,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,QAAQ;EACR,wCAAwC;EACxC,mCAA2B;UAA3B,2BAA2B;EAC3B,SAAS;EACT,YAAY;EACZ,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;AACV;;AAEA,6DAA6D;;AAC7D;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA,2DAA2D;;AAC3D;EACE,4BAA4B;EAC5B,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,kDAAkD;EAClD,yCAAyC;EACzC,iBAAiB;EACjB,+BAA+B;EAC/B,mBAAmB;EACnB,6BAA6B;EAC7B,mCAAmC;EACnC,mCAA2B;UAA3B,2BAA2B;AAC7B;;AAEA;EACE,4BAA4B;EAC5B,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,kDAAkD;EAClD,yCAAyC;EACzC,+BAA+B;EAC/B,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;EACd,qBAAgB;OAAhB,gBAAgB;EAChB,mCAAmC;EACnC,mCAA2B;UAA3B,2BAA2B;AAC7B;;AAEA;EACE,gCAAgC;AAClC;;AAEA,+FAA+F;;AAC/F;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,gBAAgB;EAChB,SAAS;EACT,kBAAkB;EAClB,WAAW;EACX,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,wBAAwB;EACxB,4BAA4B;EAC5B,4BAA4B;EAC5B,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,4BAA4B;EAC5B,wBAAwB;EACxB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,4BAA4B;EAC5B,qBAAqB;AACvB;;AAEA;EACE,kCAAkC;EAClC,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA,6FAA6F;;AAC7F,sEAAsE;;AACtE;EACE,kBAAkB;EAClB,QAAQ;EACR,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;AACf;;AAEA;EACE,2BAAoB;EAApB,2BAAoB;EAApB,oBAAoB;AACtB;;AAEA;EACE,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;AACrB;;AAEA;EACE,yBAA8B;MAA9B,sBAA8B;UAA9B,8BAA8B;AAChC;;AAEA;EACE,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;AACzB;;AAEA,sEAAsE;;AACtE;EACE,eAAe;EACf,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;;;;EAIE,+BAA+B;AACjC;;AAEA;EACE,iDAAiD;AACnD;;AAEA;;;;EAIE,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,2CAA2C;AAC7C;;AAEA,kFAAkF;;AAClF;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,oBAAc;MAAd,cAAc;AAChB;;AAEA,4FAA4F;;AAC5F;EACE,WAAW;EACX,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,4CAA4C;EAC5C,kBAAkB;EAClB,qBAAqB;EACrB,YAAY;EACZ,0CAA0C;AAC5C;;AAEA;EACE;AACF;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,yBAAyB;EACzB,eAAe;EACf,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,UAAU;EACV,WAAW;EACX,0CAA0C;EAC1C,kBAAkB;EAClB,eAAe;EACf,qBAAqB;EACrB,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,uCAAuC;EACvC,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;AACb;;AAEA,4BAA4B;;AAE5B;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,qBAAqB;EACrB,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;AACrB;;AAEA;EACE,mBAAe;MAAf,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,2BAA2B;EAC3B,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;AACrB;;AAEA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,qBAAqB;EACrB,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,yBAA8B;MAA9B,sBAA8B;UAA9B,8BAA8B;AAChC;;AAEA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,qBAAqB;EACrB,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,mBAAe;MAAf,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,qBAAqB;EACrB,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,qBAAyB;MAAzB,kBAAyB;UAAzB,yBAAyB;AAC3B;;AAEA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,qBAAqB;EACrB,mBAAe;MAAf,eAAe;EACf,uBAAuB;EACvB,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;AACzB;;AAEA;EACE,yBAA8B;MAA9B,sBAA8B;UAA9B,8BAA8B;AAChC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,cAAc;EACd,uCAAuC;EACvC,mCAAmC;EACnC,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,8CAA8C;AAChD;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,6BAA6B;EAC7B,eAAe;EACf,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;;;;;EAKE,qBAAqB;EACrB,+BAA+B;AACjC;;AAEA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;EACvB,uBAAe;KAAf,oBAAe;UAAf,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,uCAAuC;EACvC,4BAA4B;EAC5B,4BAA4B;EAC5B,WAAW;EACX,kBAAkB;EAClB,oCAAoC;EACpC,iCAAiC;EACjC,gCAAgC;EAChC,+BAA+B;AACjC;;AAEA;EACE,mCAA2B;UAA3B,2BAA2B;EAC3B,kBAAkB;EAClB,2BAAoB;EAApB,2BAAoB;EAApB,oBAAoB;EACpB,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,0CAA0C;EAC1C,6BAA6B;EAC7B,YAAY;EACZ,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAmB;KAAnB,mBAAmB;EACnB,yCAAyC;EACzC,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,+BAA+B;EAC/B,eAAe;AACjB;;AAEA;EACE,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;;;;EAIE,+BAA+B;;AAEjC;;AAEA;EACE,uBAAe;KAAf,oBAAe;UAAf,eAAe;EACf,eAAe;EACf,+BAA+B;EAC/B,kBAAkB;EAClB,mBAAe;MAAf,eAAe;AACjB;;AAEA;EACE,MAAM;AACR;;AAEA;EACE,+BAA+B;EAC/B,sBAAsB;AACxB;;AAEA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,4BAAsB;EAAtB,6BAAsB;MAAtB,0BAAsB;UAAtB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,uCAAuC;AACzC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,MAAM;EACN,WAAW;EACX,WAAW;EACX,YAAY;EACZ,mCAAmC;EACnC,6BAA6B;EAC7B,+BAA+B;EAC/B,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;EACrB,QAAQ;EACR,SAAS;EACT,YAAY;EACZ,8BAA8B;EAC9B,cAAc;EACd,2CAA2C;EAC3C,MAAM;EACN,UAAU;EACV,WAAW;EACX,2BAA2B;EAC3B,yDAAyD;AAC3D;;AAEA;EACE,mCAAmC;EACnC,wBAAwB;EACxB,YAAY;EACZ,2BAAoB;EAApB,2BAAoB;EAApB,oBAAoB;EACpB,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,iCAAiC;EACjC,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;;;;;;;EAOE,wBAAwB;EACxB,mCAAmC;EACnC,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,+BAA+B;EAC/B,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAmB;KAAnB,mBAAmB;AACrB;;AAEA;EACE,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mCAAmC;EACnC,mBAAmB;EACnB,uCAAuC;EACvC,eAAe;AACjB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,uCAAuC;EACvC,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;;;EAIE,YAAY;EACZ,wCAAwC;EACxC,mCAA2B;UAA3B,2BAA2B;AAC7B;;AAEA;EACE,iDAAiD;AACnD;;AAEA;EACE,uCAAuC;EACvC,yCAAiC;UAAjC,iCAAiC;EACjC,kBAAkB;EAClB,aAAa;AACf;;AAEA;;;;EAIE,6BAA6B;EAC7B,YAAY;EACZ,mCAA2B;UAA3B,2BAA2B;EAC3B,wCAAwC;EACxC,eAAe;EACf,+BAA+B;EAC/B,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;EACnC,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,sBAAqB;MAArB,mBAAqB;UAArB,qBAAqB;AACvB;;AAEA;EACE,qBAAyB;MAAzB,kBAAyB;UAAzB,yBAAyB;AAC3B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,2BAAqB;MAArB,wBAAqB;UAArB,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAGA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,SAAS;EACT,cAAc;EACd,mBAAY;MAAZ,oBAAY;UAAZ,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,SAAS;EACT,cAAc;EACd,mBAAe;MAAf,eAAe;AACjB;;AAEA;EACE,qBAAyB;MAAzB,kBAAyB;UAAzB,yBAAyB;AAC3B;;AAEA;EACE,wCAAwC;EACxC,+BAA+B;EAC/B,UAAU;EACV,aAAa;EACb,oCAA4B;UAA5B,4BAA4B;EAC5B,iDAAiD;EACjD,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,iBAAiB;EACjB,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;;;;EAIE,+BAA+B;EAC/B,iDAAiD;AACnD;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,QAAQ;AACV;;AAEA;EACE,8CAA8C;EAC9C,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,2BAA0B;UAA1B,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE;AACF;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,SAAS;AACX;;AAEA;EACE;AACF;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAY;MAAZ,oBAAY;UAAZ,YAAY;AACd;;AAEA,aAAa;;AACb;EACE,mBAAmB;EACnB,WAAW;EACX,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,0CAA0C;EAC1C,wCAAwC;AAC1C;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,sBAAmB;KAAnB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,4BAA4B;EAC5B,0BAAuB;KAAvB,uBAAuB;EACvB,wBAAwB;EACxB,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,cAAc;EACd,8CAA8C;EAC9C,gBAAgB;EAChB,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,4CAA4C;EAC5C,mBAAmB;EACnB,gCAAgC;EAChC,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,2CAA2C;EAC3C,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,2DAA2D;EAC3D,YAAY;EACZ,OAAO;EACP,QAAQ;AACV;;AAGA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,eAAe;EACf,gCAAgC;EAChC,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,2BAA0B;UAA1B,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,0CAA0C;EAC1C,kBAAkB;EAClB,SAAS;EACT,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE;IACE,2BAA2B;IAC3B,wBAAwB;IACxB;EACF;AACF;;AAGA;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,WAAW;EACb;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,oBAAoB;IACpB,mBAAe;QAAf,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,cAAc;EAChB;;EAEA;;IAEE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,4BAAsB;IAAtB,6BAAsB;QAAtB,0BAAsB;YAAtB,sBAAsB;IACtB,wBAAuB;QAAvB,qBAAuB;YAAvB,uBAAuB;EACzB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,4BAAsB;IAAtB,6BAAsB;QAAtB,0BAAsB;YAAtB,sBAAsB;EACxB;;EAEA;IACE,4BAAsB;IAAtB,6BAAsB;QAAtB,0BAAsB;YAAtB,sBAAsB;EACxB;;EAEA;IACE,cAAc;IACd,WAAW;IACX,mBAAmB;EACrB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;;IAEE,gBAAgB;EAClB;;EAEA;IACE,SAAS;IACT,WAAW;EACb;;EAEA;IACE,4BAAsB;IAAtB,6BAAsB;QAAtB,0BAAsB;YAAtB,sBAAsB;IACtB,wBAAuB;QAAvB,qBAAuB;YAAvB,uBAAuB;EACzB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,WAAW;IACX,mBAAe;QAAf,eAAe;EACjB;;EAEA;IACE,sBAAqB;QAArB,mBAAqB;YAArB,qBAAqB;EACvB;;EAEA;IACE,4BAAsB;IAAtB,6BAAsB;QAAtB,0BAAsB;YAAtB,sBAAsB;IACtB,0BAAoB;QAApB,uBAAoB;YAApB,oBAAoB;IACpB,aAAa;EACf;AACF;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,wBAAgB;KAAhB,qBAAgB;UAAhB,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,iBAAiB;EACjB,2CAA2C;EAC3C,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,8CAA8C;AAChD;;AAEA;EACE;IACE,gDAAgD;EAClD;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,gDAAgD;EAClD;;EAEA;IACE,4BAAsB;IAAtB,6BAAsB;QAAtB,0BAAsB;YAAtB,sBAAsB;EACxB;;EAEA;IACE,0BAAoB;QAApB,uBAAoB;YAApB,oBAAoB;EACtB;AACF;;AC5iDA;CACC,iBAAiB;CACjB,WAAW;CACX,cAAc;CACd,cAAc;AACf;;AAEA;CACC,4BAA4B;CAC5B,mBAAmB;CACnB,uCAAuC;AACxC;;AAEA;CACC,yCAAiC;SAAjC,iCAAiC;CACjC,kBAAkB;CAClB,aAAa;AACd;;AAEA;CACC,gCAAgC;AACjC;;AAEA;CACC,gCAAgC;AACjC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,aAAa;CACb,uCAAuC;CACvC,kBAAkB;AACnB;;AAEA;CACC,iCAAiC;CACjC,gBAAgB;CAChB,mBAAmB;AACpB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC;EACC,eAAe;CAChB;;CAEA;;;EAGC,aAAa;CACd;AACD","sourcesContent":[".btnPrimary {\n  border-color: var(--btn-primary-bg) !important;\n  background-color: var(--btn-primary-bg) !important;\n  color: var(--btn-primary-color) !important;\n  padding: 11px 20px;\n  font-weight: 500;\n  font-size: 18px;\n  border-radius: 6px;\n  box-shadow: none !important;\n  text-decoration: none !important;\n  cursor: pointer;\n  line-height: 24px;\n  display: inline-block;\n}\n\n.btnPrimary:hover,\n.btnPrimary:focus,\n.btnPrimary:active,\n.btnPrimary:active:hover,\n.btnPrimary:active:focus,\n.btnPrimary[disabled]:hover,\n.btnPrimary[disabled]:focus {\n  border-color: var(--btn-primary-bg-hover) !important;\n  background-color: var(--btn-primary-bg-hover) !important;\n  color: var(--btn-primary-color) !important;\n  box-shadow: none !important;\n}\n\n.btnPrimaryBorder {\n  color: var(--btn-primaryBorder-color) !important;\n  background-color: var(--btn-primaryBorder-bg) !important;\n  padding: 11px 20px;\n  font-weight: 500;\n  font-size: 18px;\n  border-radius: 6px;\n  box-shadow: none !important;\n  text-decoration: none !important;\n  border: 1px solid var(--btn-primaryBorder-color) !important;\n  cursor: pointer;\n  line-height: 24px;\n  display: inline-block;\n}\n\n.btnPrimaryBorder:hover,\n.btnPrimaryBorder:focus,\n.btnPrimaryBorder:active,\n.btnPrimaryBorder:active:hover,\n.btnPrimaryBorder:active:focus {\n  color: var(--btn-primaryBorder-color) !important;\n  background-color: var(--btn-primaryBorder-bg) !important;\n  box-shadow: none !important;\n}\n\n.btnSecondary {\n  border: 1px solid var(--btn-secondary-bg) !important;\n  background-color: var(--primary-white-bg) !important;\n  color: var(--btn-secondary-bg) !important;\n  padding: 11px 20px;\n  font-weight: 500;\n  font-size: 18px;\n  line-height: 24px;\n  box-shadow: none !important;\n}\n\n.btnSecondary:hover,\n.btnSecondary:focus,\n.btnSecondary:active,\n.btnSecondary:active:hover,\n.btnSecondary:active:focus {\n  border-color: var(--btn-secondary-bg) !important;\n  background-color: var(--btn-secondary-bg) !important;\n  color: var(--white-text) !important;\n  box-shadow: none !important;\n}\n\n.btnPrimaryLink {\n  border: 1px solid var(--btn-primaryBorder-color) !important;\n}\n\n.nofocus:active:focus {\n  background: var(--primary-white-bg) !important;\n  color: var(--btn-primaryBorder-color) !important;\n}\n\n.btnSmall {\n  padding: 5px 0px;\n}\n\n.btnBig {\n  padding: 12px 21px !important;\n}\n\n.fullWidth {\n  width: 100%;\n}\n\n.WidthAuto {\n  width: auto;\n}\n\n.fullHeight {\n  height: 100%;\n}\n\n.noTextDecration {\n  text-decoration: none !important;\n}\n\n.commonListStyleNone {\n  list-style-type: none;\n  margin: 0;\n  padding: 0;\n}\n\n.btnMedium,\n.btnMedium:hover,\n.btnMedium:focus,\n.btnMedium:focus:hover,\n.btnMedium:active,\n.btnMedium:active:hover {\n  padding-inline: 19px !important;\n  white-space: normal;\n}\n\n.btnMediumSpace,\n.btnMediumSpace:hover,\n.btnMediumSpace:focus,\n.btnMediumSpace:focus:hover,\n.btnMediumSpace:active,\n.btnMediumSpace:active:hover {\n  padding-inline: 19px !important;\n  white-space: normal;\n}\n\n.btnMediumPadding,\n.btnMediumPadding:hover,\n.btnMediumPadding:focus,\n.btnMediumPadding:active,\n.btnMediumPadding:active:hover,\n.btnMediumPadding:focus:hover {\n  padding: 12px 19px;\n}\n\n.aiAskButton {\n  padding: 12px 18px;\n  border: unset !important;\n  outline: unset !important;\n  border-radius: 24px 24px 24px 6px;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 20px;\n  color: var(--primary-foreground);\n  box-shadow: 0px 2px 6px 0px #EA672021 !important;\n  background: var(--ai-badge-bg) !important;\n  position: relative;\n  opacity: 1 !important;\n}\n\n.aiBadgeStyle {\n  display: inline-flex;\n  gap: 4px;\n  background: var(--ai-badge-bg);\n  border-radius: 100px;\n  position: relative;\n  box-shadow: 0px 2px 6px 0px #EA672021;\n  font-weight: 500;\n  font-size: 18px;\n  line-height: 24px;\n  padding: 4px 12px;\n}\n\n.aiTextColor {\n  background: var(--ai-foreground);\n  background-clip: text;\n  -webkit-text-fill-color: transparent;\n}\n\n.aiBadgeStyle>svg {\n  position: relative;\n  top: 2px;\n}\n\n.aiAskButton::after,\n.aiBadgeStyle::after {\n  content: '';\n  position: absolute;\n  inset: -1px;\n  background: var(--ai-border);\n  border-radius: inherit;\n  z-index: -1;\n}\n\n.aiFooterInfoText {\n  font-size: 12px;\n  line-height: 18px;\n  color: var(--secondary-foreground);\n  display: inline-block;\n  font-weight: 500;\n}\n\n.regenerateBtn {\n  font-size: 16px;\n  line-height: 22px;\n  font-weight: 500;\n  display: flex;\n  gap: 4px;\n  background-color: transparent !important;\n  box-shadow: none !important;\n  border: 0;\n  padding: 0px;\n  align-items: center;\n}\n\n.regenerateBtn>svg {\n  position: relative;\n  top: 3px;\n}\n\n/************************ text Align ************************/\n.textAlignRight {\n  text-align: right;\n}\n\n.textAlignLeft {\n  text-align: left;\n}\n\n.textAlignCenter {\n  text-align: center;\n}\n\n/************************ text Align end ******************/\n.formControlInput {\n  padding: 10px 19px 10px 19px;\n  height: 48px;\n  border-radius: 6px;\n  font-size: 16px;\n  border: 1px solid var(--primary-border) !important;\n  background-color: var(--primary-white-bg);\n  line-height: 24px;\n  color: var(--common-text-color);\n  font-weight: normal;\n  border: 1px solid transparent;\n  -webkit-appearance: none !important;\n  box-shadow: none !important;\n}\n\n.formControlSelect {\n  padding: 10px 35px 10px 19px;\n  height: 48px;\n  border-radius: 6px;\n  font-size: 16px;\n  border: 1px solid var(--primary-border) !important;\n  background-color: var(--primary-white-bg);\n  color: var(--common-text-color);\n  line-height: 19px;\n  font-weight: normal;\n  display: block;\n  appearance: none;\n  -webkit-appearance: none !important;\n  box-shadow: none !important;\n}\n\n.noTextDecoration {\n  text-decoration: none !important;\n}\n\n/*-----------------------Profilephoto Upload Common Styles Start----------------------------- */\n.picContainerMain {\n  position: relative;\n}\n\n.profilePic {\n  height: 100%;\n  width: 100%;\n  border-radius: 12px;\n}\n\n.trashIcon {\n  position: absolute;\n  top: 2px;\n  right: 2px;\n  width: 22px;\n  height: 22px;\n  background: var(--common-background-color);\n  padding-top: 3px;\n  border: 0;\n  border-radius: 2px;\n  opacity: .9;\n  color: var(--white-text);\n  cursor: pointer;\n}\n\n.trashIconNew {\n  position: absolute;\n  top: 18px;\n  right: 18px;\n}\n\n.trashIconNew img {\n  width: 36px;\n}\n\n.bannerImageBg {\n  width: 100%;\n  height: 100%;\n  min-height: 179px;\n  background-size: contain;\n  background-repeat: no-repeat;\n  background-position: 50% 50%;\n  position: relative;\n  border-radius: 0px;\n}\n\n.profileImageBg {\n  padding-top: 36%;\n  background-repeat: no-repeat;\n  background-size: contain;\n  width: 100%;\n  height: 100%;\n  max-width: 180px;\n  margin: 0 auto;\n  background-position: 50% 50%;\n  background-size: 66px;\n}\n\n.whiteImg {\n  background: var(--modalText-color);\n  border-radius: 0px;\n}\n\n.curserPointer {\n  cursor: pointer;\n}\n\n.adminLabelTextNew {\n  font-size: 18px;\n  font-weight: 500;\n  color: var(--common-text-color);\n}\n\n/*-----------------------Profilephoto Upload Common Styles End----------------------------- */\n/******************* Admin Modal ListSetting Start *******************/\n.radioBtn {\n  position: relative;\n  top: 1px;\n  vertical-align: middle;\n  margin-left: 3px;\n}\n\n.displayinlineBlock {\n  display: inline-block;\n}\n\n.displayBlock {\n  display: block;\n}\n\n.displayFlex {\n  display: flex;\n}\n\n.inlineDisplayFlex {\n  display: inline-flex;\n}\n\n.alignCenter {\n  align-items: center;\n}\n\n.spaceBetween {\n  justify-content: space-between;\n}\n\n.alignItemFlexStart {\n  align-items: flex-start;\n}\n\n/******************* Admin Modal ListSetting Start *******************/\n.commonTitleText {\n  font-size: 36px;\n  margin: 0px;\n  word-wrap: break-word;\n}\n\n.commonSubTitleText {\n  font-size: 20px;\n  margin: 0px;\n}\n\n.commonContentText {\n  font-size: 18px;\n  margin: 0px;\n}\n\n.commonMediumText {\n  font-size: 16px;\n  margin: 0px;\n}\n\n.commonTotalText {\n  font-size: 24px;\n  margin: 0px;\n}\n\n.commonSmallText {\n  font-size: 14px;\n  margin: 0px;\n}\n\n.fontWeightExtraBold {\n  font-weight: 700;\n}\n\n.fontWeightBold {\n  font-weight: 600;\n}\n\n.fontWeightMedium {\n  font-weight: 500;\n}\n\n.fontWeightNormal {\n  font-weight: 400;\n}\n\n.textDecorationUnderLine {\n  text-decoration: underline;\n}\n\n.textDecorationNone {\n  text-decoration: none !important;\n}\n\n.siteLinkColor,\n.siteLinkColor:hover,\n.siteLinkColor:focus,\n.siteLinkColor:active {\n  color: var(--common-link-color);\n}\n\n.commonLinkBorderBottom {\n  border-bottom: 1px solid var(--common-link-color);\n}\n\n.siteTextColor,\n.siteTextColor:hover,\n.siteTextColor:focus,\n.siteTextColor:active {\n  color: var(--common-text-color);\n}\n\n.positionRelative {\n  position: relative;\n}\n\n.listingHorizoltalLine {\n  margin: 40px 0px;\n  border-top: 1px solid var(--primary-border);\n}\n\n/******************************* Common Margin Start *****************************/\n.spaceBottom0 {\n  margin-bottom: 0px;\n}\n\n.spaceBottom1 {\n  margin-bottom: 6px;\n}\n\n.spaceBottom2 {\n  margin-bottom: 12px;\n}\n\n.spaceBottom3 {\n  margin-bottom: 18px;\n}\n\n.spaceBottom4 {\n  margin-bottom: 24px;\n}\n\n.spaceBottom5 {\n  margin-bottom: 30px;\n}\n\n.spaceBottom6 {\n  margin-bottom: 36px;\n}\n\n.spaceBottom7 {\n  margin-bottom: 42px;\n}\n\n.spaceBottom8 {\n  margin-bottom: 10px;\n}\n\n.spaceTop0 {\n  margin-top: 0px;\n}\n\n.spaceTop1 {\n  margin-top: 6px;\n}\n\n.spaceTop2 {\n  margin-top: 12px;\n}\n\n.spaceTop3 {\n  margin-top: 18px;\n}\n\n.spaceTop4 {\n  margin-top: 24px;\n}\n\n.spaceTop5 {\n  margin-top: 30px;\n}\n\n.spaceTop6 {\n  margin-top: 36px;\n}\n\n.spaceTop7 {\n  margin-top: 42px;\n}\n\n.paddingBottom1 {\n  padding-bottom: 6px;\n}\n\n.paddingBottom2 {\n  padding-bottom: 12px;\n}\n\n.paddingBottom3 {\n  padding-bottom: 18px;\n}\n\n.paddingBottom4 {\n  padding-bottom: 24px;\n}\n\n.paddingBottom5 {\n  padding-bottom: 30px;\n}\n\n.paddingBottom6 {\n  padding-bottom: 36px;\n}\n\n.paddingBottom7 {\n  padding-bottom: 42px;\n}\n\n.paddingTop1 {\n  padding-top: 6px;\n}\n\n.paddingTop2 {\n  padding-top: 12px;\n}\n\n.paddingTop3 {\n  padding-top: 18px;\n}\n\n.paddingTop4 {\n  padding-top: 24px;\n}\n\n.paddingTop5 {\n  padding-top: 30px;\n}\n\n.paddingTop6 {\n  padding-top: 36px;\n}\n\n.paddingTop7 {\n  padding-top: 42px;\n}\n\n.spaceRight1 {\n  margin-right: 6px;\n}\n\n.spaceRight2 {\n  margin-right: 12px;\n}\n\n.spaceRight3 {\n  margin-right: 18px;\n}\n\n.spaceRight4 {\n  margin-right: 24px;\n}\n\n.paddingBottom8 {\n  padding-bottom: 15px;\n}\n\n.spaceTop8 {\n  margin-top: 16px;\n}\n\n.paddingBottomNone {\n  padding-bottom: 0;\n}\n\n.spaceBottom9 {\n  margin-bottom: 16px;\n}\n\n.spaceBottom10 {\n  margin-bottom: 17px;\n}\n\n.spaceBottom11 {\n  margin-bottom: 7px;\n}\n\n.spaceBottom12 {\n  margin-bottom: 20px;\n}\n\n.noPadding {\n  padding: 0px;\n}\n\n.flexShrinkNone {\n  flex-shrink: 0;\n}\n\n/******************************* Common Margin And Padding End *****************************/\n.viewListIcon {\n  width: 100%;\n  max-width: 35px;\n  min-width: 35px;\n}\n\n.blueLeftArrow {\n  padding-left: 6px;\n  position: relative;\n}\n\n.profileAvatarLink {\n  border: 2.5px solid var(--common-link-color);\n  border-radius: 50%;\n  display: inline-block;\n  padding: 7px;\n  background-color: var(--dashBoard-info-bg);\n}\n\n.profileAvatarLinkSmall {\n  padding: 2px\n}\n\n.errorMessage {\n  margin-top: 5px;\n  margin-bottom: 5px;\n  display: block;\n  color: var(--alert-color);\n  font-size: 14px;\n  font-weight: normal;\n  /* margin-left: 5px; */\n}\n\n.textTransformLowerCase {\n  text-transform: lowercase;\n}\n\n.passwordIcon {\n  position: absolute;\n  right: 18px;\n  top: 43px;\n  cursor: pointer;\n}\n\n.noMargin {\n  margin: 0px;\n}\n\n.noMarginBottom {\n  margin-bottom: 0 !important;\n}\n\n.dotCss {\n  width: 4px;\n  height: 4px;\n  background: var(--common-background-color);\n  border-radius: 50%;\n  margin: 0px 4px;\n  display: inline-block;\n  position: relative;\n  top: -3px;\n}\n\n.dateArrowMargin {\n  margin: 0px 8px;\n}\n\n.commonBorderSection {\n  --wrapper-Padding: 24px;\n  border: 1px solid var(--primary-border);\n  padding: 18px var(--wrapper-Padding);\n  border-radius: 12px;\n}\n\n.vtrMiddle {\n  vertical-align: middle;\n}\n\n.positionAvatar {\n  position: absolute;\n  top: 15px;\n  right: 15px;\n}\n\n/* display flex properties */\n\n.dFlex {\n  display: flex;\n  display: -webkit-flex;\n  align-items: center;\n}\n\n.flexWrap {\n  flex-wrap: wrap;\n}\n\n.dInlineFlex {\n  display: inline-block;\n  display: -webkit-inline-box;\n  align-items: center;\n}\n\n.dFlexContainer {\n  display: flex;\n  display: -webkit-flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.dFlexWrap {\n  display: flex;\n  display: -webkit-flex;\n  align-items: center;\n  flex-wrap: wrap;\n  -webkit-flex-wrap: wrap;\n}\n\n.dFlexWrapAlignEnd {\n  display: flex;\n  display: -webkit-flex;\n  align-items: center;\n  justify-content: flex-end;\n}\n\n.dFlexWrapAlignStart {\n  display: flex;\n  display: -webkit-flex;\n  flex-wrap: wrap;\n  -webkit-flex-wrap: wrap;\n  align-items: flex-start;\n}\n\n.justifyContentSpaceBetween {\n  justify-content: space-between;\n}\n\n.greyText {\n  color: var(--modalText-color);\n}\n\n.tripsReservationPanel {\n  border-radius: 12px;\n  width: 100%;\n  display: block;\n  border: 1px solid var(--primary-border);\n  background: var(--primary-white-bg);\n  padding: 15px 24px 24px 24px;\n}\n\n.listContainer {\n  margin: 0px;\n  padding: 0px;\n  list-style: none;\n  border-bottom: 1px solid var(--primary-border);\n}\n\n.listTabItem {\n  display: block;\n  padding: 0px 0px 7px;\n  position: relative;\n  text-align: center;\n  font-size: 18px;\n  color: var(--modalText-color);\n  cursor: pointer;\n  border-bottom: 1px solid transparent;\n  margin-right: 30px;\n}\n\n.listTabItem:hover,\n.listTabItem:active,\n.listTabItem:focus,\n.listTabItem:active:hover,\n.listTabItem:focus:hover {\n  text-decoration: none;\n  color: var(--common-text-color);\n}\n\n.reviewsContainer {\n  display: flex;\n  align-items: flex-start;\n  column-gap: 6px;\n}\n\n.reviewsYourItemsOne {\n  -webkit-box-flex: 1;\n  -ms-flex: 1 0 auto;\n  flex: 1 0 auto;\n}\n\n.reviewsYourItemsTwo {\n  -webkit-box-flex: 1;\n  -ms-flex: 1 1 100%;\n  flex: 1 1 100%;\n}\n\n.rightBg {\n  background: var(--common-gray-bg-color);\n  border-radius: 0 8px 8px 8px;\n  padding: 16px 18px 18px 18px;\n  width: 100%;\n  position: relative;\n  -webkit-border-radius: 0 8px 8px 8px;\n  -moz-border-radius: 0 8px 8px 8px;\n  -ms-border-radius: 0 8px 8px 8px;\n  -o-border-radius: 0 8px 8px 8px;\n}\n\n.commonProfileAvatarLink {\n  backface-visibility: hidden;\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  width: 68px;\n  height: 68px;\n  overflow: hidden;\n  border-radius: 50%;\n  border: 2px solid var(--common-link-color);\n  background-color: transparent;\n  padding: 3px;\n  position: relative;\n  z-index: 5;\n}\n\n.commonProfileAvatarLink img {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n  background-color: var(--primary-white-bg);\n  border-radius: 50%;\n}\n\n.writtenReviewTitle {\n  font-weight: 500;\n  margin-bottom: 6px;\n  word-break: break-word;\n  color: var(--common-text-color);\n  font-size: 18px;\n}\n\n.reviewTitleLink {\n  color: var(--common-link-color);\n  font-weight: 500;\n}\n\n.reviewTitleLink:hover,\n.reviewTitleLink:focus,\n.reviewTitleLink:active,\n.reviewTitleLink:active:hover {\n  color: var(--common-link-color);\n\n}\n\n.reviewFlex {\n  column-gap: 5px;\n  font-size: 14px;\n  color: var(--common-text-color);\n  margin-bottom: 6px;\n  flex-wrap: wrap;\n}\n\n.noTop {\n  top: 0;\n}\n\n.reviewPara {\n  color: var(--common-text-color);\n  word-break: break-word;\n}\n\n.dFlexColumn {\n  display: flex;\n  flex-direction: column;\n}\n\n.commonlineCss {\n  margin: 18px 0;\n  border: 1px solid var(--primary-border);\n}\n\n.rightBg::after {\n  content: \"\";\n  position: absolute;\n  left: -38px;\n  top: 0;\n  right: auto;\n  width: 38px;\n  height: 40px;\n  background: var(--primary-white-bg);\n  border-top-right-radius: 30px;\n  border-bottom-left-radius: 30px;\n  z-index: 3;\n}\n\n.rightBg::before {\n  content: \" \";\n  position: absolute;\n  display: inline-block;\n  width: 0;\n  height: 0;\n  bottom: auto;\n  border: 10px solid transparent;\n  border-left: 0;\n  border-right-color: var(--primary-white-bg);\n  top: 0;\n  left: auto;\n  right: 100%;\n  border-width: 0 24px 24px 0;\n  border-color: transparent #F9F9F9 transparent transparent;\n}\n\n.loadBtn {\n  border-color: var(--btn-primary-bg);\n  color: var(--white-text);\n  height: 48px;\n  display: inline-flex;\n  align-items: center;\n  background: var(--btn-primary-bg);\n  border-radius: 6px;\n  padding: 12px 19px;\n  font-size: 18px;\n  font-weight: 500;\n  cursor: pointer;\n}\n\n.loadBtn:hover,\n.loadBtn:active,\n.loadBtn:focus,\n.loadBtn:active:hover,\n.loadBtn:active:focus,\n.loadBtn[disabled]:hover,\n.loadBtn[disabled]:focus {\n  color: var(--white-text);\n  border-color: var(--btn-primary-bg);\n  background: var(--btn-primary-bg);\n}\n\n.vtrTop {\n  vertical-align: top;\n}\n\n.reviewHeadingColor {\n  color: var(--common-text-color);\n}\n\n.reviewWriteHeading {\n  font-weight: 500;\n  word-break: break-word;\n  color: var(--common-text-color);\n  font-size: 18px;\n}\n\n.noDataImgSize {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n}\n\n.justifyCenter {\n  justify-content: center;\n}\n\n.btnTextBrk {\n  white-space: normal;\n  word-break: break-word;\n}\n\n.marginInlineAuto {\n  margin-inline: auto;\n}\n\n.noItemPanel {\n  background: var(--primary-white-bg);\n  border-radius: 12px;\n  border: 1px solid var(--primary-border);\n  padding: 44px 0;\n}\n\n.textLineBreak {\n  word-break: break-word;\n}\n\n.displayBlock {\n  display: block;\n}\n\n.displayInlineBlock {\n  display: inline-block;\n}\n\n.commonContainerList {\n  width: 100%;\n  max-width: var(--max-listing-width);\n  margin: 0 auto;\n}\n\n.adminBorderWithoutPadding {\n  border: 1px solid var(--primary-border);\n  border-radius: 4px;\n}\n\n.marginRight8 {\n  margin-right: 8px;\n}\n\n.adminDotIconBtn,\n.adminDotIconBtn:hover,\n.adminDotIconBtn:focus,\n.adminDotIconBtn:active {\n  border: none;\n  background-color: transparent !important;\n  box-shadow: none !important;\n}\n\n.commonLinkBorder {\n  border-bottom: 1px solid var(--common-link-color);\n}\n\n.commonTabelDropDownBg {\n  background: var(--common-gray-bg-color);\n  box-shadow: 0px 3px 6px #00000029;\n  border-radius: 6px;\n  padding: 10px;\n}\n\n.tabelDropDownBtn,\n.tabelDropDownBtn:hover,\n.tabelDropDownBtn:active,\n.tabelDropDownBtn:focus {\n  padding: 12px 10px !important;\n  border: none;\n  box-shadow: none !important;\n  background-color: transparent !important;\n  font-size: 16px;\n  color: var(--common-text-color);\n  line-height: inherit;\n  vertical-align: top;\n  border-radius: 0;\n}\n\n.tableHorizantalLine {\n  border-color: var(--primary-border);\n  margin: 6px 0px;\n}\n\n.backArrowStyle {\n  width: 15px;\n  height: 12px;\n  margin-right: 6px;\n}\n\n.csvImageSpace {\n  margin: 0px 6px;\n}\n\n.flexEnd {\n  align-items: flex-end;\n}\n\n.justifyContentFlexEnd {\n  justify-content: flex-end;\n}\n\n.profileAvatarLinkPayment {\n  padding: 5px;\n}\n\n.alignItemBaseline {\n  align-items: baseline;\n}\n\n.payOutToolTip {\n  margin: 0 3px;\n}\n\n.tolltipMargin {\n  margin: 0 3px;\n}\n\n.textNoWrap {\n  white-space: nowrap;\n}\n\n\n.commonSearchInputFilterContainer {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  grid-gap: 16px;\n  flex-grow: 1;\n}\n\n.mobileTableSearch {\n  margin-bottom: 24px;\n  gap: 16px;\n  grid-gap: 16px;\n  flex-wrap: wrap;\n}\n\n.mobileTableOnlyLink {\n  justify-content: flex-end;\n}\n\n.linkBtnPrimaryStyle {\n  background-color: transparent !important;\n  color: var(--common-link-color);\n  padding: 0;\n  border: unset;\n  box-shadow: unset !important;\n  border-bottom: 1px solid var(--common-link-color);\n  font-weight: 500;\n  font-size: 18px;\n  text-decoration: none;\n  line-height: 26px;\n  border-radius: 0 !important;\n  white-space: normal;\n}\n\n.linkBtnPrimaryStyle:hover,\n.linkBtnPrimaryStyle:focus,\n.linkBtnPrimaryStyle:active,\n.linkBtnPrimaryStyle:active:hover {\n  color: var(--common-link-color);\n  border-bottom: 1px solid var(--common-link-color);\n}\n\n.dataTableGrid {\n  display: grid;\n  grid-template-columns: 3fr 2fr;\n  gap: 4px;\n}\n\n.paymentDivider {\n  border-bottom: 1px solid var(--primary-border);\n  padding-bottom: 12px;\n  margin-bottom: 12px;\n}\n\n.paymentDivider:last-child {\n  border-bottom: unset;\n  margin-bottom: 0;\n  padding-bottom: 0;\n}\n\n.bulletList {\n  list-style: disc;\n  padding-inline-start: 25px;\n}\n\n.commonSmallText14 {\n  font-size: 14px;\n  line-height: 20px;\n}\n\n.commonSmallText16 {\n  font-size: 16px;\n  line-height: 22px;\n}\n\n.commonSmallText18 {\n  font-size: 18px;\n  line-height: 24px;\n}\n\n.commonSmallText20 {\n  font-size: 20px;\n  line-height: 26px;\n}\n\n.commonSmallText24 {\n  font-size: 24px;\n  line-height: 30px;\n}\n\n.commonSmallText26 {\n  font-size: 26px;\n  line-height: normal;\n}\n\n.top1 {\n  top: 1px;\n}\n\n.top2 {\n  top: 2px;\n}\n\n.top3 {\n  top: 3px\n}\n\n.topMinus1 {\n  top: -1px;\n}\n\n.topMinus2 {\n  top: -2px;\n}\n\n.topMinus3 {\n  top: -3px\n}\n\n.textEnd {\n  text-align: end;\n}\n\n.textAlignCenter {\n  text-align: center;\n}\n\n.textStart {\n  text-align: start;\n}\n\n.flexGrow {\n  flex-grow: 1;\n}\n\n/* dropzone */\n.imageUploadDropzoneSection {\n  border-radius: 12px;\n  width: 100%;\n  height: 180px;\n  position: relative;\n}\n\n.imageUploadDropzoneSectionOutline {\n  background-color: var(--secondary-gray-bg);\n  border: 2px dashed var(--primary-border);\n}\n\n.commonDropZoneImgContainer {\n  position: absolute;\n  inset: 0;\n  object-fit: contain;\n  width: 100%;\n  height: 100%;\n  background-repeat: no-repeat;\n  object-position: center;\n  background-size: contain;\n  background-position: center;\n}\n\n.commonDropZoneDefaultImg {\n  background-size: 70px 70px;\n}\n\n.navTabFlex {\n  display: flex;\n  align-items: center;\n  gap: 12px 30px;\n  border-bottom: 1px solid var(--primary-border);\n  list-style: none;\n  padding: 0;\n  margin: 0 0 24px;\n}\n\n.navTabLink {\n  font-size: 18px;\n  line-height: 24px;\n  color: var(--tertiary-foreground) !important;\n  padding-bottom: 6px;\n  text-decoration: none !important;\n  position: relative;\n  text-align: center;\n  display: block;\n  cursor: pointer;\n}\n\n.navTabLink.activeTabStyle {\n  color: var(--primary-foreground) !important;\n  font-weight: 500;\n}\n\n.navTabLink.activeTabStyle::after {\n  content: \"\";\n  position: absolute;\n  width: 100%;\n  height: 1px;\n  background-color: var(--primary-link-foreground) !important;\n  bottom: -1px;\n  left: 0;\n  right: 0;\n}\n\n\n.listingCardCarTypeAndTransmissionLabelFlexContainer {\n  display: flex;\n  font-size: 14px;\n  color: var(--primary-foreground);\n  align-items: center;\n}\n\n.listingCardCarTypeAndTransmissionLabelFlexContainer>div {\n  max-width: 50%;\n}\n\n.transmissionLabelText {\n  position: relative;\n  padding-inline-start: 15px;\n}\n\n.transmissionLabelText::before {\n  content: '';\n  position: absolute;\n  width: 4px;\n  height: 4px;\n  background: var(--common-background-color);\n  border-radius: 50%;\n  left: 5px;\n  top: 8px;\n}\n\n.carTypeIcon {\n  position: relative;\n  top: -2px;\n}\n\n.textFlow {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n@media screen and (min-width:992px) {\n  .paymentSticky {\n    position: sticky !important;\n    position: -webkit-sticky;\n    top: 42px\n  }\n}\n\n\n@media (max-width: 1024px) and (min-width: 768px) {\n  .dateArrowMargin {\n    margin: 0px -10px;\n  }\n}\n\n@media screen and (max-width: 767px) {\n  .btnWidth {\n    width: 100%;\n  }\n\n  .mobTextCenter {\n    text-align: center !important;\n  }\n\n  .tripsReservationPanel {\n    padding-inline: 15px;\n  }\n\n  .listContainer {\n    border-bottom: unset;\n    flex-wrap: wrap;\n  }\n\n  .listContainer li .listTabItem {\n    margin-right: 0;\n    margin-left: 0;\n  }\n\n  .writtenReviewTitle,\n  .reviewTitleLink {\n    font-size: 16px;\n  }\n\n  .reviewFlex {\n    font-size: 12px;\n  }\n\n  .reviewPara {\n    font-size: 14px;\n  }\n\n  .commonProfileAvatarLink {\n    width: 50px;\n    height: 50px;\n  }\n\n  .reviewWriteHeading {\n    font-size: 16px;\n  }\n\n  .mobileReviewIconBox {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n  }\n\n  .mrMarginBottom {\n    margin-bottom: 5px;\n  }\n\n  .mrRemoveMargin {\n    margin-right: 0;\n  }\n\n  .mrListDeletBtnBox {\n    flex-direction: column;\n  }\n\n  .mobileFlexContainer {\n    flex-direction: column;\n  }\n\n  .mobileFlexContainer li {\n    display: block;\n    width: 100%;\n    margin-bottom: 10px;\n  }\n\n  .mobileDisplayBlock {\n    display: block;\n  }\n\n  .mobileTextCenter {\n    text-align: center;\n  }\n\n  .profileImageBg,\n  .bannerImageBg {\n    padding-top: 60%;\n  }\n\n  .trashIconNew {\n    top: 12px;\n    right: 12px;\n  }\n\n  .mobileTableSearch {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n\n  .commonBorderSection {\n    --wrapper-Padding: 18px;\n  }\n\n  .commonSearchInputFilterContainer {\n    width: 100%;\n    flex-wrap: wrap;\n  }\n\n  .mobileTableOnlyLink {\n    align-items: flex-end;\n  }\n\n  .navTabFlex {\n    flex-direction: column;\n    align-items: stretch;\n    border: unset;\n  }\n}\n\n.displayGrid {\n  display: grid;\n}\n\n.gridCols2 {\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n}\n\n.gap4 {\n  gap: 4px;\n}\n\n.gap6 {\n  gap: 6px;\n}\n\n.gap8 {\n  gap: 8px;\n}\n\n.gap12 {\n  gap: 12px;\n}\n\n.gap16 {\n  gap: 16px;\n}\n\n.gap24 {\n  gap: 24px;\n}\n\n.columnGap16 {\n  column-gap: 16px;\n}\n\n.rowGap18 {\n  row-gap: 18px;\n}\n\n.bt {\n  border-top: 1px solid var(--primary-border);\n}\n\n.languageBox>div:not(:first-child) {\n  padding-top: 24px;\n  border-top: 1px solid var(--primary-border);\n  margin-top: 24px;\n}\n\n.languageBtnContainerOne {\n  margin-bottom: 24px;\n}\n\n.languageBox>div:last-child .languageBtnContainerOne {\n  margin-bottom: 0;\n}\n\n.commonInputGrpDivider {\n  padding-bottom: 18px;\n  border-bottom: 1px solid var(--primary-border);\n}\n\n@media screen and (max-width: 991px) {\n  .gridColsTab1 {\n    grid-template-columns: repeat(1, minmax(0, 1fr));\n  }\n\n  .gapTab0 {\n    gap: 0px !important;\n  }\n}\n\n@media screen and (max-width: 767px) {\n  .gridColsMobile1 {\n    grid-template-columns: repeat(1, minmax(0, 1fr));\n  }\n\n  .mobileFlexColumn {\n    flex-direction: column;\n  }\n\n  .mobileAlignFlexStretch {\n    align-items: stretch;\n  }\n}","@import url('../../components/commonStyle.css');\n\n.landingContainer {\n\tmax-width: 1080px;\n\twidth: 100%;\n\tdisplay: block;\n\tmargin: 0 auto;\n}\n\n.cancellationBg {\n\tpadding: 26px 30px 30px 30px;\n\tborder-radius: 12px;\n\tborder: 1px solid var(--primary-border);\n}\n\n.cancelCard {\n\tbox-shadow: 0px 4px 6px #EAEAEA29;\n\tborder-radius: 8px;\n\tpadding: 24px;\n}\n\n.cancelCardOne {\n\tbackground: var(--cancel-bg-one);\n}\n\n.cancelCardTwo {\n\tbackground: var(--cancel-bg-two);\n}\n\n.cancelCardThree {\n\tbackground: var(--cancel-bg-three);\n}\n\n.cancelDescSec {\n\tpadding: 24px;\n\tbackground: var(--common-gray-bg-color);\n\tborder-radius: 8px;\n}\n\n.horizontalLine {\n\tbackground: var(--primary-border);\n\tmargin-top: 18px;\n\tmargin-bottom: 18px;\n}\n\n.descListSpaceLeft {\n\tpadding-left: 20px;\n}\n\n@media screen and (max-width: 767px) {\n\t.pageTitle {\n\t\tfont-size: 25px;\n\t}\n\n\t.cancellationBg,\n\t.cancelCard,\n\t.cancelDescSec {\n\t\tpadding: 17px;\n\t}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"btnPrimary": `CancellationPolicies-btnPrimary-TtLBW`,
	"btnPrimaryBorder": `CancellationPolicies-btnPrimaryBorder-CQ6jp`,
	"btnSecondary": `CancellationPolicies-btnSecondary-aTPYr`,
	"btnPrimaryLink": `CancellationPolicies-btnPrimaryLink-AJjL9`,
	"nofocus": `CancellationPolicies-nofocus-U7mfR`,
	"btnSmall": `CancellationPolicies-btnSmall-E1PdD`,
	"btnBig": `CancellationPolicies-btnBig-ubE4e`,
	"fullWidth": `CancellationPolicies-fullWidth-tewzv`,
	"WidthAuto": `CancellationPolicies-WidthAuto-FS_Fs`,
	"fullHeight": `CancellationPolicies-fullHeight-fZ4Ey`,
	"noTextDecration": `CancellationPolicies-noTextDecration-a_MPi`,
	"commonListStyleNone": `CancellationPolicies-commonListStyleNone-YgEbD`,
	"btnMedium": `CancellationPolicies-btnMedium-KO_9Z`,
	"btnMediumSpace": `CancellationPolicies-btnMediumSpace-MLMHT`,
	"btnMediumPadding": `CancellationPolicies-btnMediumPadding-NBHWv`,
	"aiAskButton": `CancellationPolicies-aiAskButton-fVPwo`,
	"aiBadgeStyle": `CancellationPolicies-aiBadgeStyle-ZWtPC`,
	"aiTextColor": `CancellationPolicies-aiTextColor-sNlw_`,
	"aiFooterInfoText": `CancellationPolicies-aiFooterInfoText-iZLFa`,
	"regenerateBtn": `CancellationPolicies-regenerateBtn-siEkL`,
	"textAlignRight": `CancellationPolicies-textAlignRight-JWsuS`,
	"textAlignLeft": `CancellationPolicies-textAlignLeft-dLt2K`,
	"textAlignCenter": `CancellationPolicies-textAlignCenter-mynoT`,
	"formControlInput": `CancellationPolicies-formControlInput-sgT6r`,
	"formControlSelect": `CancellationPolicies-formControlSelect-sS68L`,
	"noTextDecoration": `CancellationPolicies-noTextDecoration-TnrDr`,
	"picContainerMain": `CancellationPolicies-picContainerMain-Rq7D8`,
	"profilePic": `CancellationPolicies-profilePic-XvzWu`,
	"trashIcon": `CancellationPolicies-trashIcon-ZQpez`,
	"trashIconNew": `CancellationPolicies-trashIconNew-lIh4M`,
	"bannerImageBg": `CancellationPolicies-bannerImageBg-UTDia`,
	"profileImageBg": `CancellationPolicies-profileImageBg-ylxph`,
	"whiteImg": `CancellationPolicies-whiteImg-AC4rm`,
	"curserPointer": `CancellationPolicies-curserPointer-yHQPV`,
	"adminLabelTextNew": `CancellationPolicies-adminLabelTextNew-ih8kw`,
	"radioBtn": `CancellationPolicies-radioBtn-gvbeL`,
	"displayinlineBlock": `CancellationPolicies-displayinlineBlock-QluI1`,
	"displayBlock": `CancellationPolicies-displayBlock-baVVg`,
	"displayFlex": `CancellationPolicies-displayFlex-Jsw0h`,
	"inlineDisplayFlex": `CancellationPolicies-inlineDisplayFlex-D6zvp`,
	"alignCenter": `CancellationPolicies-alignCenter-XuWfp`,
	"spaceBetween": `CancellationPolicies-spaceBetween-UK7ZN`,
	"alignItemFlexStart": `CancellationPolicies-alignItemFlexStart-VNXvH`,
	"commonTitleText": `CancellationPolicies-commonTitleText-COX9Z`,
	"commonSubTitleText": `CancellationPolicies-commonSubTitleText-cBEe7`,
	"commonContentText": `CancellationPolicies-commonContentText-oJ7Tw`,
	"commonMediumText": `CancellationPolicies-commonMediumText-yXC4p`,
	"commonTotalText": `CancellationPolicies-commonTotalText-Xcof7`,
	"commonSmallText": `CancellationPolicies-commonSmallText-Laplp`,
	"fontWeightExtraBold": `CancellationPolicies-fontWeightExtraBold-nPvOV`,
	"fontWeightBold": `CancellationPolicies-fontWeightBold-EE2Dj`,
	"fontWeightMedium": `CancellationPolicies-fontWeightMedium-pyKv2`,
	"fontWeightNormal": `CancellationPolicies-fontWeightNormal-e7bl4`,
	"textDecorationUnderLine": `CancellationPolicies-textDecorationUnderLine-FcIIO`,
	"textDecorationNone": `CancellationPolicies-textDecorationNone-ee3Om`,
	"siteLinkColor": `CancellationPolicies-siteLinkColor-Znln2`,
	"commonLinkBorderBottom": `CancellationPolicies-commonLinkBorderBottom-uKcga`,
	"siteTextColor": `CancellationPolicies-siteTextColor-TqesO`,
	"positionRelative": `CancellationPolicies-positionRelative-mcbp8`,
	"listingHorizoltalLine": `CancellationPolicies-listingHorizoltalLine-SnFCj`,
	"spaceBottom0": `CancellationPolicies-spaceBottom0-EUCFW`,
	"spaceBottom1": `CancellationPolicies-spaceBottom1-wjP65`,
	"spaceBottom2": `CancellationPolicies-spaceBottom2-L4bL4`,
	"spaceBottom3": `CancellationPolicies-spaceBottom3-Iayvl`,
	"spaceBottom4": `CancellationPolicies-spaceBottom4-ueVd4`,
	"spaceBottom5": `CancellationPolicies-spaceBottom5-br1rF`,
	"spaceBottom6": `CancellationPolicies-spaceBottom6-nOLGr`,
	"spaceBottom7": `CancellationPolicies-spaceBottom7-Gv31S`,
	"spaceBottom8": `CancellationPolicies-spaceBottom8-i30ug`,
	"spaceTop0": `CancellationPolicies-spaceTop0-R9sxa`,
	"spaceTop1": `CancellationPolicies-spaceTop1-Nxo5t`,
	"spaceTop2": `CancellationPolicies-spaceTop2-ZuH2Y`,
	"spaceTop3": `CancellationPolicies-spaceTop3-UlLZs`,
	"spaceTop4": `CancellationPolicies-spaceTop4-fQi4o`,
	"spaceTop5": `CancellationPolicies-spaceTop5-BAHMa`,
	"spaceTop6": `CancellationPolicies-spaceTop6-xYAsV`,
	"spaceTop7": `CancellationPolicies-spaceTop7-u5RSR`,
	"paddingBottom1": `CancellationPolicies-paddingBottom1-mL18R`,
	"paddingBottom2": `CancellationPolicies-paddingBottom2-OX_Ry`,
	"paddingBottom3": `CancellationPolicies-paddingBottom3-CS_xX`,
	"paddingBottom4": `CancellationPolicies-paddingBottom4-NyPw3`,
	"paddingBottom5": `CancellationPolicies-paddingBottom5-rLOhX`,
	"paddingBottom6": `CancellationPolicies-paddingBottom6-YzWdA`,
	"paddingBottom7": `CancellationPolicies-paddingBottom7-TGKvc`,
	"paddingTop1": `CancellationPolicies-paddingTop1-Uivja`,
	"paddingTop2": `CancellationPolicies-paddingTop2-PdfWy`,
	"paddingTop3": `CancellationPolicies-paddingTop3-kCcDi`,
	"paddingTop4": `CancellationPolicies-paddingTop4-GZOOO`,
	"paddingTop5": `CancellationPolicies-paddingTop5-kYokh`,
	"paddingTop6": `CancellationPolicies-paddingTop6-M0Uyz`,
	"paddingTop7": `CancellationPolicies-paddingTop7-fh0Mx`,
	"spaceRight1": `CancellationPolicies-spaceRight1-Hat72`,
	"spaceRight2": `CancellationPolicies-spaceRight2-Dv20a`,
	"spaceRight3": `CancellationPolicies-spaceRight3-eFwPs`,
	"spaceRight4": `CancellationPolicies-spaceRight4-Yt_8H`,
	"paddingBottom8": `CancellationPolicies-paddingBottom8-pTYgE`,
	"spaceTop8": `CancellationPolicies-spaceTop8-o_7yp`,
	"paddingBottomNone": `CancellationPolicies-paddingBottomNone-t4QjJ`,
	"spaceBottom9": `CancellationPolicies-spaceBottom9-jkzq_`,
	"spaceBottom10": `CancellationPolicies-spaceBottom10-FHFWP`,
	"spaceBottom11": `CancellationPolicies-spaceBottom11-mWiWZ`,
	"spaceBottom12": `CancellationPolicies-spaceBottom12-d8Q2Z`,
	"noPadding": `CancellationPolicies-noPadding-XAWvI`,
	"flexShrinkNone": `CancellationPolicies-flexShrinkNone-VQXW0`,
	"viewListIcon": `CancellationPolicies-viewListIcon-oEicd`,
	"blueLeftArrow": `CancellationPolicies-blueLeftArrow-fVEKN`,
	"profileAvatarLink": `CancellationPolicies-profileAvatarLink-pBD2p`,
	"profileAvatarLinkSmall": `CancellationPolicies-profileAvatarLinkSmall-n5jFP`,
	"errorMessage": `CancellationPolicies-errorMessage-LC0XB`,
	"textTransformLowerCase": `CancellationPolicies-textTransformLowerCase-e0NG1`,
	"passwordIcon": `CancellationPolicies-passwordIcon-SrQIq`,
	"noMargin": `CancellationPolicies-noMargin-gom_8`,
	"noMarginBottom": `CancellationPolicies-noMarginBottom-t4QGK`,
	"dotCss": `CancellationPolicies-dotCss-iUbqR`,
	"dateArrowMargin": `CancellationPolicies-dateArrowMargin-W3L3Y`,
	"commonBorderSection": `CancellationPolicies-commonBorderSection-dt9c7`,
	"vtrMiddle": `CancellationPolicies-vtrMiddle-adCMw`,
	"positionAvatar": `CancellationPolicies-positionAvatar-ZW5VG`,
	"dFlex": `CancellationPolicies-dFlex-anA_V`,
	"flexWrap": `CancellationPolicies-flexWrap-mJCOo`,
	"dInlineFlex": `CancellationPolicies-dInlineFlex-Vr9oC`,
	"dFlexContainer": `CancellationPolicies-dFlexContainer-vm3dw`,
	"dFlexWrap": `CancellationPolicies-dFlexWrap-Q_z1E`,
	"dFlexWrapAlignEnd": `CancellationPolicies-dFlexWrapAlignEnd-eZuSU`,
	"dFlexWrapAlignStart": `CancellationPolicies-dFlexWrapAlignStart-gAgY_`,
	"justifyContentSpaceBetween": `CancellationPolicies-justifyContentSpaceBetween-WlCe1`,
	"greyText": `CancellationPolicies-greyText-gSlZe`,
	"tripsReservationPanel": `CancellationPolicies-tripsReservationPanel-UVRkB`,
	"listContainer": `CancellationPolicies-listContainer-ElS39`,
	"listTabItem": `CancellationPolicies-listTabItem-Iss1E`,
	"reviewsContainer": `CancellationPolicies-reviewsContainer-cXYSL`,
	"reviewsYourItemsOne": `CancellationPolicies-reviewsYourItemsOne-ku_hI`,
	"reviewsYourItemsTwo": `CancellationPolicies-reviewsYourItemsTwo-ogqbv`,
	"rightBg": `CancellationPolicies-rightBg-ttV5X`,
	"commonProfileAvatarLink": `CancellationPolicies-commonProfileAvatarLink-qKOBn`,
	"writtenReviewTitle": `CancellationPolicies-writtenReviewTitle-pt5js`,
	"reviewTitleLink": `CancellationPolicies-reviewTitleLink-xluCj`,
	"reviewFlex": `CancellationPolicies-reviewFlex-SzW_i`,
	"noTop": `CancellationPolicies-noTop-SxI1S`,
	"reviewPara": `CancellationPolicies-reviewPara-qOeD5`,
	"dFlexColumn": `CancellationPolicies-dFlexColumn-Zd5ot`,
	"commonlineCss": `CancellationPolicies-commonlineCss-R8Mxo`,
	"loadBtn": `CancellationPolicies-loadBtn-kyuSs`,
	"vtrTop": `CancellationPolicies-vtrTop-wDpGC`,
	"reviewHeadingColor": `CancellationPolicies-reviewHeadingColor-fCxaV`,
	"reviewWriteHeading": `CancellationPolicies-reviewWriteHeading-bECBG`,
	"noDataImgSize": `CancellationPolicies-noDataImgSize-lXtUl`,
	"justifyCenter": `CancellationPolicies-justifyCenter-XZ7FR`,
	"btnTextBrk": `CancellationPolicies-btnTextBrk-ZuysL`,
	"marginInlineAuto": `CancellationPolicies-marginInlineAuto-AgcrJ`,
	"noItemPanel": `CancellationPolicies-noItemPanel-DeoV1`,
	"textLineBreak": `CancellationPolicies-textLineBreak-_wktl`,
	"displayInlineBlock": `CancellationPolicies-displayInlineBlock-AQSsk`,
	"commonContainerList": `CancellationPolicies-commonContainerList-mHz1L`,
	"adminBorderWithoutPadding": `CancellationPolicies-adminBorderWithoutPadding-g8JoW`,
	"marginRight8": `CancellationPolicies-marginRight8-DWrOn`,
	"adminDotIconBtn": `CancellationPolicies-adminDotIconBtn-e75hj`,
	"commonLinkBorder": `CancellationPolicies-commonLinkBorder-zsH76`,
	"commonTabelDropDownBg": `CancellationPolicies-commonTabelDropDownBg-JO5Uw`,
	"tabelDropDownBtn": `CancellationPolicies-tabelDropDownBtn-CNTvx`,
	"tableHorizantalLine": `CancellationPolicies-tableHorizantalLine-IkrDo`,
	"backArrowStyle": `CancellationPolicies-backArrowStyle-XKYGh`,
	"csvImageSpace": `CancellationPolicies-csvImageSpace-hpDhq`,
	"flexEnd": `CancellationPolicies-flexEnd-rOttG`,
	"justifyContentFlexEnd": `CancellationPolicies-justifyContentFlexEnd-SeLW1`,
	"profileAvatarLinkPayment": `CancellationPolicies-profileAvatarLinkPayment-_kAkW`,
	"alignItemBaseline": `CancellationPolicies-alignItemBaseline-rv0Ie`,
	"payOutToolTip": `CancellationPolicies-payOutToolTip-YiCX7`,
	"tolltipMargin": `CancellationPolicies-tolltipMargin-zc9hX`,
	"textNoWrap": `CancellationPolicies-textNoWrap-_aBgd`,
	"commonSearchInputFilterContainer": `CancellationPolicies-commonSearchInputFilterContainer-UyFcM`,
	"mobileTableSearch": `CancellationPolicies-mobileTableSearch-CUbqO`,
	"mobileTableOnlyLink": `CancellationPolicies-mobileTableOnlyLink-iIaiI`,
	"linkBtnPrimaryStyle": `CancellationPolicies-linkBtnPrimaryStyle-FxxGF`,
	"dataTableGrid": `CancellationPolicies-dataTableGrid-NdGMD`,
	"paymentDivider": `CancellationPolicies-paymentDivider-RbmWy`,
	"bulletList": `CancellationPolicies-bulletList-URpsQ`,
	"commonSmallText14": `CancellationPolicies-commonSmallText14-aUtwZ`,
	"commonSmallText16": `CancellationPolicies-commonSmallText16-I_5Rw`,
	"commonSmallText18": `CancellationPolicies-commonSmallText18-X026L`,
	"commonSmallText20": `CancellationPolicies-commonSmallText20-EX2VG`,
	"commonSmallText24": `CancellationPolicies-commonSmallText24-T3TEg`,
	"commonSmallText26": `CancellationPolicies-commonSmallText26-rw45L`,
	"top1": `CancellationPolicies-top1-b8RlY`,
	"top2": `CancellationPolicies-top2-roKN1`,
	"top3": `CancellationPolicies-top3-dljRQ`,
	"topMinus1": `CancellationPolicies-topMinus1-bI9Rj`,
	"topMinus2": `CancellationPolicies-topMinus2-c_VeI`,
	"topMinus3": `CancellationPolicies-topMinus3-f7uea`,
	"textEnd": `CancellationPolicies-textEnd-u6PlR`,
	"textStart": `CancellationPolicies-textStart-bZVnE`,
	"flexGrow": `CancellationPolicies-flexGrow-TjZ0u`,
	"imageUploadDropzoneSection": `CancellationPolicies-imageUploadDropzoneSection-zTHFV`,
	"imageUploadDropzoneSectionOutline": `CancellationPolicies-imageUploadDropzoneSectionOutline-qU0S8`,
	"commonDropZoneImgContainer": `CancellationPolicies-commonDropZoneImgContainer-JrbRV`,
	"commonDropZoneDefaultImg": `CancellationPolicies-commonDropZoneDefaultImg-A7S0o`,
	"navTabFlex": `CancellationPolicies-navTabFlex-rZW2k`,
	"navTabLink": `CancellationPolicies-navTabLink-lPw3q`,
	"activeTabStyle": `CancellationPolicies-activeTabStyle-CeJkM`,
	"listingCardCarTypeAndTransmissionLabelFlexContainer": `CancellationPolicies-listingCardCarTypeAndTransmissionLabelFlexContainer-drJjW`,
	"transmissionLabelText": `CancellationPolicies-transmissionLabelText-ABeke`,
	"carTypeIcon": `CancellationPolicies-carTypeIcon-Kjw6S`,
	"textFlow": `CancellationPolicies-textFlow-AlRL3`,
	"paymentSticky": `CancellationPolicies-paymentSticky-Dlufb`,
	"btnWidth": `CancellationPolicies-btnWidth-QN77E`,
	"mobTextCenter": `CancellationPolicies-mobTextCenter-_XzAc`,
	"mobileReviewIconBox": `CancellationPolicies-mobileReviewIconBox-SZ93H`,
	"mrMarginBottom": `CancellationPolicies-mrMarginBottom-ffROL`,
	"mrRemoveMargin": `CancellationPolicies-mrRemoveMargin-ZGh5L`,
	"mrListDeletBtnBox": `CancellationPolicies-mrListDeletBtnBox-M8KgG`,
	"mobileFlexContainer": `CancellationPolicies-mobileFlexContainer-k0hFb`,
	"mobileDisplayBlock": `CancellationPolicies-mobileDisplayBlock-ATdKL`,
	"mobileTextCenter": `CancellationPolicies-mobileTextCenter-Msg54`,
	"displayGrid": `CancellationPolicies-displayGrid-WNP2L`,
	"gridCols2": `CancellationPolicies-gridCols2-frTNJ`,
	"gap4": `CancellationPolicies-gap4-yDOpv`,
	"gap6": `CancellationPolicies-gap6-hfbRi`,
	"gap8": `CancellationPolicies-gap8-yHTsp`,
	"gap12": `CancellationPolicies-gap12-HfHWo`,
	"gap16": `CancellationPolicies-gap16-Ssk7O`,
	"gap24": `CancellationPolicies-gap24-mdexX`,
	"columnGap16": `CancellationPolicies-columnGap16-Sjs8u`,
	"rowGap18": `CancellationPolicies-rowGap18-NxgNN`,
	"bt": `CancellationPolicies-bt-pRyY3`,
	"languageBox": `CancellationPolicies-languageBox-nI0mm`,
	"languageBtnContainerOne": `CancellationPolicies-languageBtnContainerOne-jqJw4`,
	"commonInputGrpDivider": `CancellationPolicies-commonInputGrpDivider-Rt4ZZ`,
	"gridColsTab1": `CancellationPolicies-gridColsTab1-gtQvl`,
	"gapTab0": `CancellationPolicies-gapTab0-it4KK`,
	"gridColsMobile1": `CancellationPolicies-gridColsMobile1-Dayfd`,
	"mobileFlexColumn": `CancellationPolicies-mobileFlexColumn-D70ZX`,
	"mobileAlignFlexStretch": `CancellationPolicies-mobileAlignFlexStretch-kW4j2`,
	"landingContainer": `CancellationPolicies-landingContainer-FfNF9`,
	"cancellationBg": `CancellationPolicies-cancellationBg-gGFxI`,
	"cancelCard": `CancellationPolicies-cancelCard-Y7G1B`,
	"cancelCardOne": `CancellationPolicies-cancelCardOne-_mRCb`,
	"cancelCardTwo": `CancellationPolicies-cancelCardTwo-qUHmb`,
	"cancelCardThree": `CancellationPolicies-cancelCardThree-bn48Z`,
	"cancelDescSec": `CancellationPolicies-cancelDescSec-d4doZ`,
	"horizontalLine": `CancellationPolicies-horizontalLine-Gr73t`,
	"descListSpaceLeft": `CancellationPolicies-descListSpaceLeft-kp9Tk`,
	"pageTitle": `CancellationPolicies-pageTitle-Wg6rB`
};
module.exports = ___CSS_LOADER_EXPORT___;
